import { expm1 } from "core-js/library/fn/number";

export const OLED_START =
`#include <Wire.h>\n#include <Adafruit_GFX.h>\n#include <Adafruit_SSD1306.h>\n#include <oled_lib_cus.h>\n#define SCREEN_WIDTH 128\n#define SCREEN_HEIGHT 64\n#define OLED_RESET 4\n#define SCREEN_ADDRESS 0x3C
\nenum Emotion {
  Mat_chop,
  Cuoi_hip_mat,
  Mat_cuoi,
  Mat_buon,
  Mat_noi_chuyen,
  Nhuc_mat,
  Xoay_vong,
  Mat_cute,
  Cuoi_haha,
  Mat_cau_kinh,
  Mat_tuc_gian,
  Mat_dangngu,
  Mat_ngau,
  Mat_quy_ong,
};

enum Effect {
  Left2Right,
  Right2Left,
  Bottom2Top,
  Top2Bottom,
};

Adafruit_SSD1306 display(SCREEN_WIDTH, SCREEN_HEIGHT, &Wire, OLED_RESET);

int current_emotion;
int last_emotion = E_NULL;
unsigned long time;

int index =0;
unsigned long interval = 10;
unsigned long previos_time =0;
unsigned long current = 0;

void eye_blink(){
  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,closed_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();
}


void smiling_eye() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
  display.clearDisplay();
  display.drawBitmap(0,0,laugh_until_eyes_closed,128,64,WHITE);
  display.display();
}

void smile_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
  display.clearDisplay();
  display.drawBitmap(0,0,smile,128,64,WHITE);
  display.display();
}

void sad_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
  display.clearDisplay();
  display.drawBitmap(0,0,sad,128,64,WHITE);
  display.display();
}

void talking() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }

  display.clearDisplay();
  display.drawBitmap(0,0,talk,128,64,WHITE);
  display.display();
}

void eye_pain() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }

  display.clearDisplay();
  display.drawBitmap(0,0,happy,128,64,WHITE);
  display.display();
}

void shock() {
  unsigned long time  = millis();
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
    time = millis();
  }

  if(millis() - time <= 50){
    display.clearDisplay();
    display.drawBitmap(0,0,shock1,128,64,WHITE);
    display.display();
  }

  else if(millis() - time > 50){
    display.clearDisplay();
    display.drawBitmap(0,0,shock2,128,64,WHITE);
    display.display();
    if(millis() - time > 100)time = millis();
  }
  delay(50);
}

void laugh() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }

  display.clearDisplay();
  display.drawBitmap(0,0,cute,128,64,WHITE);
  display.display();
}

void laugh_haha() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
    time = millis();
  }

  if(millis() - time <= 50){
    display.clearDisplay();
    display.drawBitmap(0,0,laugh_haha1,128,64,WHITE);
    display.display();
  }

  else if(millis() - time > 50){
    display.clearDisplay();
    display.drawBitmap(0,0,laugh_haha2,128,64,WHITE);
    display.display();
    if(millis() - time > 100)time = millis();
  }
}

void cranky_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }

  display.clearDisplay();
  display.drawBitmap(0,0,MAT_LUOM,128,64,WHITE);
  display.display();
}

void angry_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
    time = millis();
  }

  if(millis() - time <= 50){
    display.clearDisplay();
    display.drawBitmap(0,0,angry1,128,64,WHITE);
    display.display();
  }

  else if(millis() - time > 50){
    display.clearDisplay();
    display.drawBitmap(0,0,angry2,128,64,WHITE);
    display.display();
    if(millis() - time > 100)time = millis();
  }
}

void sleeping() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
    time = millis();
  }

  if(millis() - time <= 50){
    display.clearDisplay();
    display.drawBitmap(0,0,sleep1,128,64,WHITE);
    display.display();
  }

  else if(millis() - time > 50){
    display.clearDisplay();
    display.drawBitmap(0,0,sleep2,128,64,WHITE);
    display.display();
    if(millis() - time > 100)time = millis();
  }
}

void thief_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
    time = millis();
  }

  if(millis() - time <= 50){
    display.clearDisplay();
    display.drawBitmap(0,0,thief_face1,128,64,WHITE);
    display.display();
  }

  else if(millis() - time > 50){
    display.clearDisplay();
    display.drawBitmap(0,0,thief_face2,128,64,WHITE);
    display.display();
    if(millis() - time > 100)time = millis();
  }
}

void gentle_face() {
  if (last_emotion != current_emotion) {
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }

  display.clearDisplay();
  display.drawBitmap(0,0,gentle,128,64,WHITE);
  display.display();
}

void print_emotion(int emo){
  current_emotion = emo;
  switch (emo){
    case Mat_chop:
    {
      eye_blink();
      break;
    }
    case Cuoi_hip_mat:
    {
      smiling_eye();
      break;
    }
    case Mat_cuoi:
    {
      smile_face();
      break;
    }
    case Mat_buon:
    {
      sad_face();
      break;
    }
    case Mat_noi_chuyen:
    {
      talking();
      break;
    }
    case Nhuc_mat:
    {
      eye_pain();
      break;
    }
    case Xoay_vong:
    {
      shock();
      break;
    }
    case Mat_cute:
    {
      laugh();
      break;
    }
    case Cuoi_haha:
    {
      laugh_haha();
      break;
    }
    case Mat_cau_kinh:
    {
      cranky_face();
      break;
    }
    case Mat_tuc_gian:
    {
      angry_face();
      break;
    }
    case Mat_dangngu:
    {
      sleeping();
      break;
    }
    case Mat_ngau:
    {
      thief_face();
      break;
    }
    case Mat_quy_ong:
    {
      gentle_face();
      break;
    }
    default:
    {
      ;
    }
  }
}

void scrollTextLeftToRight(int scrollSpeed, String message, int x, int y, int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index += 1;
    if (index >= 128) index = -messageLength;
    display.setCursor(index, y);
    display.print(message);
    display.display();
  }
}

void scrollTextRightToLeft(int scrollSpeed, String message, int x, int y, int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index -= 1;
    if(index <= -messageLength) index = 128;
    display.setCursor(index, y);
    display.print(message);
    display.display();
  }
}

void scrollTextTopToBottom(int scrollSpeed, String message, int x, int y,int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index += 1;
    if(index >= 64) index = -messageLength;
      display.clearDisplay();
    display.setCursor(x, index);
    display.print(message);
    display.display();
  }
}

void scrollTextBottomToTop(int scrollSpeed, String message, int x, int y,int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index -= 1;
    if(index <= -messageLength) index = 64;
      display.clearDisplay();
    display.setCursor(x, index);
    display.print(message);
    display.display();
  }
}

void scrollText(int ta, int scrollSpeed, String message, int x, int y, int size) {
  display.clearDisplay();
  scrollSpeed = 10 - scrollSpeed;
  switch (ta) {
    case Left2Right: {
      scrollTextLeftToRight(scrollSpeed, message, x, y, size);
      break;
    }
    case Right2Left: {
      scrollTextRightToLeft(scrollSpeed, message, x, y, size);
      break;
    }
    case Bottom2Top: {
      scrollTextTopToBottom(scrollSpeed, message, x, y, size);
      break;
    }
    case Top2Bottom: {
      scrollTextBottomToTop(scrollSpeed, message, x, y, size);
      break;
    }
  }
}

void oled_print_char(String message, int x, int y,int size) {
  display.clearDisplay();
  display.setTextSize(size);
  display.setTextColor(WHITE);
  display.setCursor(x, y);
  display.print(message);
  display.display();
}

void oled_print_number(int number, int x, int y,int size) {
  display.clearDisplay();
  display.setTextSize(size);
  display.setTextColor(WHITE);
  display.setCursor(x, y);
  display.print(number);
  display.display();
}
`
;
export const OLED_SETUP =
`if (!display.begin(SSD1306_SWITCHCAPVCC, SCREEN_ADDRESS)) {
    Serial.println(F("SSD1306 allocation failed"));
    for (;;);
}
display.clearDisplay();
display.setTextColor(WHITE);
display.setTextWrap(false);
`
;

export const INFRARED_SENSOR_START =
`#include <IRremote.h>
#define IR_REMOTE_UP 16718055
#define IR_REMOTE_DOWN 16730805
#define IR_REMOTE_LEFT 16716015
#define IR_REMOTE_RIGHT 16734885
#define IR_REMOTE_OK 16726215
#define IR_REMOTE_ASTERIK 16738455
#define IR_REMOTE_POUND 16756815
#define IR_REMOTE_0 16750695
#define IR_REMOTE_1 16753245
#define IR_REMOTE_2 16736925
#define IR_REMOTE_3 16769565
#define IR_REMOTE_4 16720605
#define IR_REMOTE_5 16712445
#define IR_REMOTE_6 16761405
#define IR_REMOTE_7 16769055
#define IR_REMOTE_8 16754775
#define IR_REMOTE_9 16748655

int nutdk;
IRrecv irrecv(A1); // chân của IR sensor
decode_results results;`;

export const button_start = `#define BUTTON_LEFT 7
#define BUTTON_RIGHT 8

unsigned long lastDebounceTime = 0;
char status_button = 0;
char Count_Button_7 = -1;
char Count_Button_8 = -1;
char Number_Button_7 = 0;
char Number_Button_8 = 0;
char Times_Button_7 = 0;
char Times_Button_8 = 0;

int button_debounce(int Pin_Button) {
  int reading = digitalRead(Pin_Button);

  if ((millis() - lastDebounceTime) > 200) {
    if (reading == LOW && status_button == 0) {  // LOW nghĩa là nhấn nút
      lastDebounceTime = millis();
      status_button = 1;
      return 1;  // Nhấn mới
    } else if (reading == HIGH) {
      status_button = 0;  // Reset khi thả nút
    }
  }

  return 0; // Không nhấn mới
}`;

export const bluetooth_start = `#include <SoftwareSerial.h>\n
SoftwareSerial ble_at09(3, 2);// RX, TX
String LeeString;
String voiceMessage;
String dataSend;
int so_nguyen_1;
unsigned long long mau_so_nguyen = 0 ;

void Connect() {
  voiceMessage = "";
  if (ble_at09.available() > 0) {
    char c = ble_at09.read();
    if (c != '\\n') {
      LeeString += c;
    } else {
      if (LeeString.startsWith("voice:")) {
        int startPos = LeeString.indexOf("{") + 1;
        int endPos = LeeString.indexOf("}", startPos);
        voiceMessage = LeeString.substring(startPos, endPos);
        Serial.println(voiceMessage);
      } else {
        Serial.println(LeeString);
      }
      LeeString = "";
    }
  }
}

int chuyen_doi_dimmer(String dimmer){
    if (dimmer != ""){
    int indexDimmer = dimmer.indexOf(':');
    String phan_so_nguyen_1 = dimmer.substring(indexDimmer + 1);
    so_nguyen_1 = phan_so_nguyen_1.toInt();
    }
    return so_nguyen_1  ;
}

unsigned long long chuyen_doi_mau_sac(String mau_sac) {
  if (mau_sac != ""){
  int indexColon = mau_sac.indexOf(':');
  String phan_so_nguyen = mau_sac.substring(indexColon + 1);
  mau_so_nguyen = strtoul(phan_so_nguyen.c_str(), NULL, 16);
  }
  return mau_so_nguyen;
}`;

export const example_star_war_setup = `#include <IRremote.h>
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>
#include <Fonts/FreeSans9pt7b.h>
#include <SPI.h>
#include <TimerFreeTone.h>

#define IR_REMOTE_UP 16718055
#define IR_REMOTE_DOWN 16730805
#define IR_REMOTE_LEFT 16716015
#define IR_REMOTE_RIGHT 16734885
#define IR_REMOTE_OK 16726215
#define IR_REMOTE_STAR 16738455

const int receiverPin = A1;
IRrecv irrecv(receiverPin);
decode_results results;

#define OLED_RESET 4
#define ANCHO_PANTALLA 128 // Ancho de la pantalla OLED
#define ALTO_PANTALLA 64 // Alto de la pantalla OLED
Adafruit_SSD1306 display(ANCHO_PANTALLA, ALTO_PANTALLA, &Wire, OLED_RESET);

const int c = 261;
const int d = 294;
const int e = 329;
const int f = 349;
const int g = 391;
const int gS = 415;
const int a = 440;
const int aS = 455;
const int b = 466;
const int cH = 523;
const int cSH = 554;
const int dH = 587;
const int dSH = 622;
const int eH = 659;
const int fH = 698;
const int fSH = 740;
const int gH = 784;
const int gSH = 830;
const int aH = 880;

const unsigned char PROGMEM dioda16 [] = {

  0x00, 0x00, 0x00, 0x00, 0x1C, 0x00, 0x3F, 0xF0, 0x3C, 0x00, 0x3C, 0x00, 0xFF, 0x00, 0x7F, 0xFF,
  0x7F, 0xFF, 0xFF, 0x00, 0x3C, 0x00, 0x3C, 0x00, 0x1F, 0xF0, 0x1C, 0x00, 0x00, 0x00, 0x00, 0x00

};

const unsigned char PROGMEM storm [] = {
  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
  0x00, 0x00, 0x00, 0x00, 0x7F, 0xFE, 0x00, 0x00, 0x00, 0x07, 0x80, 0x01, 0xE0, 0x00, 0x00, 0x0C,
  0x00, 0x00, 0x20, 0x00, 0x00, 0x18, 0x00, 0x00, 0x18, 0x00, 0x00, 0x30, 0x00, 0x00, 0x04, 0x00,
  0x00, 0x20, 0x00, 0x00, 0x04, 0x00, 0x00, 0x20, 0x00, 0x00, 0x04, 0x00, 0x00, 0x60, 0x00, 0x00,
  0x02, 0x00, 0x00, 0x40, 0x00, 0x00, 0x02, 0x00, 0x00, 0x40, 0x00, 0x00, 0x01, 0x00, 0x00, 0x40,
  0x00, 0x00, 0x01, 0x00, 0x00, 0x40, 0x00, 0x00, 0x01, 0x00, 0x00, 0x7F, 0xE0, 0x00, 0x01, 0x00,
  0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0xD7, 0xFF, 0xFF,
  0xE1, 0x00, 0x01, 0xBF, 0xFC, 0x1F, 0xFA, 0x80, 0x01, 0xBF, 0xF1, 0xCF, 0xFA, 0x80, 0x01, 0x3F,
  0xC2, 0x37, 0xF7, 0x80, 0x01, 0xEF, 0x9C, 0x01, 0xE7, 0xC0, 0x01, 0xE0, 0x70, 0x06, 0x06, 0x80,
  0x01, 0xE0, 0xC0, 0x03, 0x06, 0x80, 0x01, 0xFF, 0x80, 0x01, 0xFF, 0x80, 0x01, 0xF8, 0x00, 0x00,
  0x1D, 0xC0, 0x03, 0x70, 0x00, 0x80, 0x0C, 0x60, 0x05, 0xB0, 0x07, 0xF0, 0x08, 0x90, 0x09, 0x10,
  0x1F, 0xF8, 0x09, 0xD0, 0x0B, 0x90, 0x1F, 0x7C, 0x03, 0xF0, 0x0F, 0xC0, 0xFC, 0x0F, 0x07, 0x90,
  0x0D, 0x43, 0xC0, 0x03, 0x07, 0x90, 0x05, 0x64, 0x00, 0x00, 0xCF, 0x10, 0x07, 0xFC, 0x00, 0x00,
  0x26, 0x10, 0x01, 0x80, 0x00, 0x00, 0x10, 0x20, 0x01, 0x00, 0x00, 0x00, 0x0E, 0x40, 0x01, 0x80,
  0x07, 0xF0, 0x01, 0x80, 0x00, 0x80, 0x07, 0xC8, 0x00, 0x80, 0x00, 0x80, 0x0B, 0xE8, 0x00, 0x80,
  0x00, 0x87, 0x97, 0xE9, 0xE0, 0x80, 0x00, 0x87, 0xDF, 0xEF, 0xA0, 0x80, 0x00, 0x4B, 0xFF, 0xFF,
  0xA0, 0x80, 0x00, 0x6B, 0xDF, 0xFB, 0xA3, 0x00, 0x00, 0x24, 0x97, 0xE8, 0x24, 0x00, 0x00, 0x1E,
  0x1F, 0xC0, 0x2C, 0x00, 0x00, 0x07, 0xF8, 0x1F, 0xF0, 0x00, 0x00, 0x00, 0x0F, 0xF8, 0x00, 0x00
};

int metx = 0;
int mety = 0;
int postoji = 0;
int nep = 8;
int smjer = 0;
int go = 0;
int rx = 95;
int ry = 0;
int rx2 = 95;
int ry2 = 0;
int rx3 = 95;
int ry3 = 0;
int bodovi = 0;

int brzina = 3; //speed of bullet
int bkugle = 1;
int najmanja = 600;
int najveca = 1200;
int promjer = 10;

int rx4 = 95;
int ry4 = 0;
int zivoti = 5;
int poc = 0;
int ispaljeno = 0;
int nivo = 1;
int centar = 95;
unsigned long pocetno = 0;
unsigned long odabrano = 0;
unsigned long trenutno = 0;
unsigned long nivovrije = 0;
int poz = 30;

int value_move = 0;
int status_game = 0;
int save_time = 0;

void ponovo()
{
  metx = 0;
  mety = 0;
  postoji = 0;
  nep = 8;
  smjer = 0;
  go = 0;
  rx = 95;
  ry = 0;
  rx2 = 95;
  ry2 = 0;
  rx3 = 95;
  ry3 = 0;
  bodovi = 0;

  brzina = 3; //brizna neprijateljevog metka
  bkugle = 1;
  najmanja = 600;
  najveca = 1200;
  promjer = 12;

  rx4 = 95;
  ry4 = 0;
  zivoti = 5;
  poc = 0;
  ispaljeno = 0;
  nivo = 1;
  pocetno = 0;
  odabrano = 0;
  trenutno = 0;
  nivovrije = 0;
}

long readVcc() {
  // Read 1.1V reference against AVcc
  // set the reference to Vcc and the measurement to the internal 1.1V reference
#if defined(__AVR_ATmega32U4__) || defined(__AVR_ATmega1280__) || defined(__AVR_ATmega2560__)
  ADMUX = _BV(REFS0) | _BV(MUX4) | _BV(MUX3) | _BV(MUX2) | _BV(MUX1);
#elif defined (__AVR_ATtiny24__) || defined(__AVR_ATtiny44__) || defined(__AVR_ATtiny84__)
  ADMUX = _BV(MUX5) | _BV(MUX0);
#elif defined (__AVR_ATtiny25__) || defined(__AVR_ATtiny45__) || defined(__AVR_ATtiny85__)
  ADMUX = _BV(MUX3) | _BV(MUX2);
#else
  ADMUX = _BV(REFS0) | _BV(MUX3) | _BV(MUX2) | _BV(MUX1);
#endif

  delay(2); // Wait for Vref to settle
  ADCSRA |= _BV(ADSC); // Start conversion
  while (bit_is_set(ADCSRA, ADSC)); // measuring

  uint8_t low  = ADCL; // must read ADCL first - it then locks ADCH
  uint8_t high = ADCH; // unlocks both

  long result = (high << 8) | low;

  result = 1125300L / result; // Calculate Vcc (in mV); 1125300 = 1.1*1023*1000
  return result; // Vcc in millivolts
}


void beep(int note, int duration)
{
  //Play tone on buzzerPin
  TimerFreeTone(10, note, duration);
  delay(duration);
  delay(50);
}`;

export const example_star_war_setup_function = `
display.begin(SSD1306_SWITCHCAPVCC, 0x3C);
display.display();
display.clearDisplay();
display.setTextSize(0);
display.drawBitmap(6, 11, storm, 48, 48, 1);
display.setFont(&FreeSans9pt7b);
display.setTextColor(WHITE);
display.setCursor(65, 14);
display.println("xWing");
display.setFont();
display.setCursor(65, 17);
display.setTextSize(0);
display.println("vs");
display.setCursor(0, 0);
float voltaza = readVcc() / 1000;
display.println(voltaza);;
display.setFont(&FreeSans9pt7b);
display.setCursor(65, 39);
display.println("Death");
display.setFont();
display.setCursor(65, 42);
display.println("star ");
display.setTextSize(0);

display.setCursor(65, 55);
display.println("by Danko");
display.setCursor(65, 20);
display.display();

display.setFont();
beep(a, 500);
beep(a, 500);
beep(a, 500);
beep(f, 350);
beep(cH, 150);
beep(a, 500);
beep(f, 350);
beep(cH, 150);
beep(a, 650);
delay(500);
delay(500);
irrecv.enableIRIn(); // start the IR receiver


  if (irrecv.decode(&results))
  {
    switch(results.value){
      case IR_REMOTE_UP: value_move = 1;
                        break;
      case IR_REMOTE_DOWN: value_move = 2;
                        break;
      case IR_REMOTE_OK: value_move = 3;
                        break;
      case IR_REMOTE_STAR: ponovo();
                            status_game = 0;
                            save_time = millis()/1000;
                            break;
    }
    irrecv.resume();
  }

  if (go == 0) {
    display.clearDisplay();


    display.drawPixel(50, 30, 1);
    display.drawPixel(30, 17, 1);
    display.drawPixel(60, 18, 1);
    display.drawPixel(55, 16, 1);
    display.drawPixel(25, 43, 1);
    display.drawPixel(100, 43, 1);
    display.drawPixel(117, 52, 1);
    display.drawPixel(14, 49, 1);
    display.drawPixel(24, 24, 1);
    display.drawPixel(78, 36, 1);
    display.drawPixel(80, 57, 1);
    display.drawPixel(107, 11, 1);
    display.drawPixel(150, 11, 1);
    display.drawPixel(5, 5, 1);
    display.drawPixel(8, 7, 1);
    display.drawPixel(70, 12, 1);
    display.drawPixel(10, 56, 1);
    display.drawPixel(70, 25, 1);
    if (poc == 0) {
      pocetno = millis();
      odabrano = random(400, 1200);
      poc = 1;
    }
    trenutno = millis();
    //nivoi

    if ((trenutno - nivovrije) > 50000)
    {
      nivovrije = trenutno;
      nivo = nivo + 1;

      brzina = brzina + 1; //brizna neprijateljevog metka
      if ( nivo % 2 == 0 )
      {
        bkugle = bkugle + 1;
        promjer = promjer - 1;
      }
      najmanja = najmanja - 50;
      najveca = najveca - 50;

    }
    if ((odabrano + pocetno) < trenutno)
    {
      poc = 0;
      ispaljeno = ispaljeno + 1;
      if (ispaljeno == 1)
      { rx = 95;
        ry = nep;
      }
      if (ispaljeno == 2) {
        rx2 = 95;
        ry2 = nep;
      }
      if (ispaljeno == 3)
      {
        rx3 = 95;
        ry3 = nep;
      }
      if (ispaljeno == 4) {
        rx4 = 95;
        ry4 = nep;
      }
    }
    if (ispaljeno > 0)
    {
      display.drawCircle(rx, ry, 2, 1);
      rx = rx - brzina;
    }

    if (ispaljeno > 1)
    {
      display.drawCircle(rx2, ry2, 1, 1);
      rx2 = rx2 - brzina;
    }

    if (ispaljeno > 2)
    {
      display.drawCircle(rx3, ry3, 4, 1);
      rx3 = rx3 - brzina;
    }

    if (ispaljeno > 3)
    {
      display.drawCircle(rx4, ry4, 2, 1);
      rx4 = rx4 - brzina;

    }

    if (value_move == 1 && poz >= 2) {
      poz = poz - 2;
    }

    if (value_move == 2 && poz <= 46) {
      poz = poz + 2;
    }


    if (value_move == 3 && postoji == 0)
    {
      postoji = 1;
      metx = 6;
      mety = poz + 8;
      TimerFreeTone(10, 1200, 20);

    }
    if (postoji == 1)

    {
      metx = metx + 8 ;
      display.drawLine(metx, mety, metx + 4, mety, 1);
    }

    display.drawBitmap(4, poz, dioda16, 16, 16, 1);
    display.fillCircle(centar, nep, promjer, 1);
    display.fillCircle(centar + 2, nep + 3, promjer / 3, 0);

    display.setTextSize(1);
    display.setTextColor(WHITE);
    display.setCursor(33, 57);
    display.println("score:");
    display.setCursor(68, 57);
    display.println(bodovi);

    display.setCursor(33, 0);
    display.println("lives:");
    display.setCursor(68, 0);
    display.println(zivoti);

    display.setCursor(110, 0);
    display.println("L:");

    display.setCursor(122, 0);
    display.println(nivo);

    display.setCursor(108, 57);
    int save_time_1 = trenutno / 1000;
    int save_time_2 = save_time_1 - save_time;
    display.println(save_time_2);
    display.display();

    if (metx > 128)postoji = 0;



    if (smjer == 0) {
      nep = nep + bkugle;
    }
    else
    {
      nep = nep - bkugle;
    }

    if (nep >= (64 - promjer))
      smjer = 1;
    if (nep <= promjer)
      smjer = 0;

    if (mety >= nep - promjer && mety <= nep + promjer)
      if (metx > (centar - promjer) && metx < (centar + promjer))
      {
        metx = -20;
        TimerFreeTone(10, 500, 20);
        bodovi = bodovi + 1;
        postoji = 0;
      }

    int pozicija = poz + 8;
    if (ry >= pozicija - 8 && ry <= pozicija + 8)
      if (rx < 12 && rx > 4)
      {
        rx = 95;
        ry = -50;
        TimerFreeTone(10, 100, 100);
        zivoti = zivoti - 1;
      }

    if (ry2 >= pozicija - 8 && ry2 <= pozicija + 8)
      if (rx2 < 12 && rx2 > 4)
      {
        rx2 = -50;
        ry2 = -50;
        TimerFreeTone(10, 100, 100);
        zivoti = zivoti - 1;
      }

    if (ry3 >= pozicija - 8 && ry3 <= pozicija + 8)
      if (rx3 < 12 && rx3 > 4)
      {
        rx3 = -50;
        ry3 = -50;
        TimerFreeTone(10, 100, 100);
        zivoti = zivoti - 1;
      }

    if (ry4 >= pozicija - 8 && ry4 <= pozicija + 8)
      if (rx4 < 12 && rx4 > 4)
      {
        rx4 = 200;
        ry4 = -50;
        ispaljeno = 0;
        TimerFreeTone(10, 100, 100);
        zivoti = zivoti - 1;
      }

    if (rx4 < 1) {
      ispaljeno = 0;
      rx4 = 200;
    }

    if (zivoti == 0)
      go = 1;
  }

  if (go == 1 && status_game == 0)
  {
    if (zivoti == 0) {
      TimerFreeTone(10, 200, 300);
      delay(300);
      TimerFreeTone(10, 250, 200);
      delay(200);
      TimerFreeTone(10, 300, 300);
      delay(300);
      zivoti = 5;
    }
    display.clearDisplay();
    display.setFont();
    display.setTextSize(2);
    display.setTextColor(WHITE);
    display.setCursor(7, 10);
    display.println("GAME OVER!");
    display.setTextSize(1);
    display.setCursor(7, 30);
    display.println("score:");
    display.setCursor(44, 30);
    display.println(bodovi);
    display.setCursor(7, 40);
    display.println("level:");
    display.setCursor(44, 40);
    display.println(nivo);
    display.setCursor(7, 50);
    display.println("time(s):");
    display.setCursor(60, 50);

    int save_time_1 = trenutno / 1000;
    int save_time_2 = save_time_1 - save_time;

    //save_time = save_time_1;
    display.println(save_time_2);
    display.display();

    if (value_move == 3 == 0)
    {
      TimerFreeTone(10, 280, 300);
      delay(300);
      TimerFreeTone(10, 250, 200);
      delay(200);
      TimerFreeTone(10, 370, 300);
      delay(300);
      //ponovo();
      status_game = 1;
      value_move = 0;
    }
  }

  results.value = 0;\n`;

  export const example_soccer_player_def = `#include <IRremote.h>
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>
#include <oled_lib_cus.h>
#include <SPI.h>

#define WIDTH 128
#define HEIGTH 64
#define OLED_RESET 4
#define SCREEN_ADDRESS 0x3C

#define MOTORA_1 5
#define MOTORA_2 12
#define MOTORB_1 6
#define MOTORB_2 13

#define IR_REMOTE_UP 16718055
#define IR_REMOTE_DOWN 16730805
#define IR_REMOTE_LEFT 16716015
#define IR_REMOTE_RIGHT 16734885
#define IR_REMOTE_OK 16726215
#define IR_REMOTE_HOLD 4294967295

const int receiverPin = A1;
IRrecv irrecv(receiverPin);
decode_results results;

Adafruit_SSD1306 display(WIDTH, HEIGTH, &Wire, OLED_RESET);
int current_emotion;
int last_emotion = E_NULL;

void eye_blink(){
  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,closed_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();

}
void smiling_eye(){
  if(last_emotion != current_emotion){
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
    display.clearDisplay();
    display.drawBitmap(0,0,laugh_until_eyes_closed,128,64,WHITE);
    display.display();

}
void smile_face(){
   if(last_emotion != current_emotion){
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
    display.clearDisplay();
    display.drawBitmap(0,0,smile,128,64,WHITE);
    display.display();
}
void laugh(){//cute
   if(last_emotion != current_emotion){
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
    display.clearDisplay();
    display.drawBitmap(0,0,cute,128,64,WHITE);
    display.display();
}
void talking(){
   if(last_emotion != current_emotion){
    display.clearDisplay();
    display.drawBitmap(0,0,opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
    display.display();

    display.clearDisplay();
    display.drawBitmap(0,0,closed_eye,128,64,WHITE);
    display.display();
    last_emotion = current_emotion;
  }
  display.clearDisplay();
  display.drawBitmap(0,0,talk,128,64,WHITE);
  display.display();
}

void print_emotion(int emo){
  current_emotion = emo;
  switch (emo){
    case EYE_BLINK:
    {
      eye_blink();
      break;
    }
    case SMILING_EYE:
    {
      smiling_eye();
      break;
    }
    case SMILE_FACE:
    {
      smile_face();
      break;
    }
    case LAUGH:
    {
      laugh();
      break;
    }
    case TALKING:
    {
      talking();
      break;
    }
  }
}

void ROBOT_MOVE_UP(){
  digitalWrite(MOTORA_1,LOW);
  digitalWrite(MOTORA_2,HIGH);
  digitalWrite(MOTORB_1,HIGH);
  digitalWrite(MOTORB_2,LOW);
}

void ROBOT_MOVE_DOWN(){
  digitalWrite(MOTORA_1,HIGH);
  digitalWrite(MOTORA_2,LOW);
  digitalWrite(MOTORB_1,LOW);
  digitalWrite(MOTORB_2,HIGH);
}

void ROBOT_TURN_LEFT(){
  digitalWrite(MOTORA_1,LOW);
  digitalWrite(MOTORA_2,LOW);
  digitalWrite(MOTORB_1,HIGH);
  digitalWrite(MOTORB_2,LOW);
}

void ROBOT_TURN_RIGHT(){
  digitalWrite(MOTORA_1,LOW);
  digitalWrite(MOTORA_2,HIGH);
  digitalWrite(MOTORB_1,LOW);
  digitalWrite(MOTORB_2,LOW);
}

void ROBOT_STOP(){
  digitalWrite(MOTORA_1,LOW);
  digitalWrite(MOTORA_2,LOW);
  digitalWrite(MOTORB_1,LOW);
  digitalWrite(MOTORB_2,LOW);
}

unsigned long time;
int value_before = 0;
int value_now = 0;
int count_hold = 0;`;

export const example_soccer_player_setup = `pinMode(MOTORA_1,OUTPUT);
pinMode(MOTORA_2,OUTPUT);
pinMode(MOTORB_1,OUTPUT);
pinMode(MOTORB_2,OUTPUT);
irrecv.enableIRIn(); // start the IR receiver

time = millis();

if(!display.begin(SSD1306_SWITCHCAPVCC, SCREEN_ADDRESS)) {
    Serial.println(F("OLED ERROR CONNECT!"));
    for(;;);
}
print_emotion(EYE_BLINK);


    if (irrecv.decode(&results)) // nếu nhận được tín hiệu
    {
      irrecv.resume(); // nhận giá trị tiếp theo
      Serial.println(results.value, HEX);

      if( value_now != results.value){
        value_before = value_now;
        value_now = results.value;
      }

      if (results.value == IR_REMOTE_HOLD){
        count_hold ++;
        Serial.println(count_hold);
      }

      if(count_hold >= 3){
        switch(value_before)
        {
          case IR_REMOTE_UP: ROBOT_MOVE_UP();
                              print_emotion(TALKING);
                              break;
          case IR_REMOTE_DOWN: ROBOT_MOVE_DOWN();
                                print_emotion(SMILING_EYE);
                                break;
          case IR_REMOTE_RIGHT: ROBOT_TURN_RIGHT();
                                print_emotion(SMILE_FACE);
                                break;
          case IR_REMOTE_LEFT: ROBOT_TURN_LEFT();
                                print_emotion(LAUGH);
                                break;
          case IR_REMOTE_OK: ROBOT_STOP();
                              print_emotion(EYE_BLINK);
                              break;
        }
      }

      if(results.value != IR_REMOTE_HOLD){
        count_hold = 0;
      }
      time = millis();
    }
    else{
      if( (unsigned long)(millis() - time) > 200){
        ROBOT_STOP();
        print_emotion(EYE_BLINK);
        time = millis();
      }
    }\n`;

export const password_setup_1 = `
#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>
#include <oled_lib_cus.h>
#include <SPI.h>
#include <oled_number.h>
#include <IRremote.h>

#define SCREEN_WIDTH 128
#define SCREEN_HEIGHT 64
#define OLED_RESET 4
#define SCREEN_ADDRESS 0x3C

#define IR_REMOTE_UP 16718055
#define IR_REMOTE_DOWN 16730805
#define IR_REMOTE_LEFT 16716015
#define IR_REMOTE_RIGHT 16734885
#define IR_REMOTE_OK 16726215
#define IR_REMOTE_ASTERIK 16738455
#define IR_REMOTE_POUND 16756815

#define IR_REMOTE_0 16750695
#define IR_REMOTE_1 16753245
#define IR_REMOTE_2 16736925
#define IR_REMOTE_3 16769565
#define IR_REMOTE_4 16720605
#define IR_REMOTE_5 16712445
#define IR_REMOTE_6 16761405
#define IR_REMOTE_7 16769055
#define IR_REMOTE_8 16754775
#define IR_REMOTE_9 16748655
Adafruit_SSD1306 display(SCREEN_WIDTH, SCREEN_HEIGHT, &Wire, OLED_RESET);\n`;

export const password_setup_2 = `
decode_results results;

int index =0;
unsigned long interval = 10;
unsigned long previos_time =0;
unsigned long current = 0;
enum Effect {
  Left2Right,
  Right2Left,
  Bottom2Top,
  Top2Bottom,
};

void eye_blink(){
  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,closed_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,semi_opened_eye,128,64,WHITE);
  display.display();

  display.clearDisplay();
  display.drawBitmap(0,0,opened_eye,128,64,WHITE);
  display.display();
}


int check_number_IR_REMOTE(int value) {
switch (value) {
    case IR_REMOTE_0:
    {
        return 0;
    }
    case IR_REMOTE_1:
    {
        return 1;
    }
    case IR_REMOTE_2:
    {
        return 2;
    }
    case IR_REMOTE_3:
    {
        return 3;
    }
    case IR_REMOTE_4:
    {
        return 4;
    }
    case IR_REMOTE_5:
    {
        return 5;
    }
    case IR_REMOTE_6:
    {
        return 6;
    }
    case IR_REMOTE_7:
    {
        return 7;
    }
    case IR_REMOTE_8:
    {
        return 8;
    }
    case IR_REMOTE_9:
    {
        return 9;
    }
    default:{
        return 10;
    }
  }
}

void check_print_number(int value,int vi_tri_print){
switch (value){
    case 0:
    {
    display.drawBitmap(vi_tri_print,0,Number_Zero,32,64,WHITE);
    break;
    }
    case 1:
    {
    display.drawBitmap(vi_tri_print,0,Number_One,32,64,WHITE);
    break;
    }
    case 2:
    {
    display.drawBitmap(vi_tri_print,0,Number_Two,32,64,WHITE);
    break;
    }
    case 3:
    {
    display.drawBitmap(vi_tri_print,0,Number_Three,32,64,WHITE);
    break;
    }
    case 4:
    {
    display.drawBitmap(vi_tri_print,0,Number_Four,32,64,WHITE);
    break;
    }
    case 5:
    {
    display.drawBitmap(vi_tri_print,0,Number_Five,32,64,WHITE);
    break;
    }
    case 6:
    {
    display.drawBitmap(vi_tri_print,0,Number_Six,32,64,WHITE);
    break;
    }
    case 7:
    {
    display.drawBitmap(vi_tri_print,0,Number_Seven,32,64,WHITE);
    break;
    }
    case 8:
    {
    display.drawBitmap(vi_tri_print,0,Number_Eight,32,64,WHITE);
    break;
    }
    case 9:
    {
    display.drawBitmap(vi_tri_print,0,Number_Nine,32,64,WHITE);
    break;
    }
  }
}

int check_number_oled(int arr[], int vi_tri_mang){
switch(vi_tri_mang){
    case 0:
    {
    display.clearDisplay();
    check_print_number(arr[0],0);
    display.drawBitmap(32,0,No_Number,32,64,WHITE);
    display.drawBitmap(64,0,No_Number,32,64,WHITE);
    display.drawBitmap(96,0,No_Number,32,64,WHITE);
    display.display();
    break;
    }

    case 1:
    {
    display.clearDisplay();
    check_print_number(arr[0],0);
    check_print_number(arr[1],32);
    display.drawBitmap(64,0,No_Number,32,64,WHITE);
    display.drawBitmap(96,0,No_Number,32,64,WHITE);
    display.display();
    break;
    }

    case 2:
    {
    display.clearDisplay();
    check_print_number(arr[0],0);
    check_print_number(arr[1],32);
    check_print_number(arr[2],64);
    display.drawBitmap(96,0,No_Number,32,64,WHITE);
    display.display();
    break;
    }

    case 3:
    {
    display.clearDisplay();
    check_print_number(arr[0],0);
    check_print_number(arr[1],32);
    check_print_number(arr[2],64);
    check_print_number(arr[3],96);
    display.display();
    break;
    }

    default:{

    }
  }
}

void scrollTextLeftToRight(int scrollSpeed, String message, int x, int y, int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index += 1;
    if (index >= 128) index = -messageLength;
    display.setCursor(index, y);
    display.print(message);
    display.display();
  }
}

void scrollTextRightToLeft(int scrollSpeed, String message, int x, int y, int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index -= 1;
    if(index <= -messageLength) index = 128;
    display.setCursor(index, y);
    display.print(message);
    display.display();
  }
}

void scrollTextTopToBottom(int scrollSpeed, String message, int x, int y,int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index += 1;
    if(index >= 64) index = -messageLength;
      display.clearDisplay();
    display.setCursor(x, index);
    display.print(message);
    display.display();
  }
}

void scrollTextBottomToTop(int scrollSpeed, String message, int x, int y,int size) {
  display.setTextSize(size);
  int messageLength = (message.length() * size * 6) + size;
  current = millis();
  if(current - previos_time >= scrollSpeed){
    previos_time = current;
    index -= 1;
    if(index <= -messageLength) index = 64;
      display.clearDisplay();
    display.setCursor(x, index);
    display.print(message);
    display.display();
  }
}

void scrollText(int ta, int scrollSpeed, String message, int x, int y, int size) {
  display.clearDisplay();
  scrollSpeed = 10 - scrollSpeed;
  switch (ta) {
    case Left2Right: {
      scrollTextLeftToRight(scrollSpeed, message, x, y, size);
      break;
    }
    case Right2Left: {
      scrollTextRightToLeft(scrollSpeed, message, x, y, size);
      break;
    }
    case Bottom2Top: {
      scrollTextTopToBottom(scrollSpeed, message, x, y, size);
      break;
    }
    case Top2Bottom: {
      scrollTextBottomToTop(scrollSpeed, message, x, y, size);
      break;
    }
  }
}

void oled_print_char(String message, int x, int y,int size) {
  display.clearDisplay();
  display.setTextSize(size);
  display.setTextColor(WHITE);
  display.setCursor(x, y);
  display.print(message);
  display.display();
}

void oled_print_number(int number, int x, int y,int size) {
  display.clearDisplay();
  display.setTextSize(size);
  display.setTextColor(WHITE);
  display.setCursor(x, y);
  display.print(number);
  display.display();
}

int Result_Password = 2;
int save_data[4];
int i = 0;\n`;

export const password_progress = `if (irrecv.decode(&results)) // nếu nhận được tín hiệu
{
  irrecv.resume(); // nhận giá trị tiếp theo
  save_data[i] = check_number_IR_REMOTE(results.value);
  if(save_data[i] == 10){
  }
  else{
    check_number_oled(save_data,i);
    i = i + 1;
    if(i == 4){
      i = 0;
      if(check_password(save_data) == true){
        Result_Password = 1;
      }
      else{
        Result_Password = 0;
      }
    }
  }
}\n`;

export const Oled_start_code = `
TwoWire* oledWire = (OLED_BUS == 0) ? &Wire : &Wire1;

#define SCREEN_WIDTH 128
#define SCREEN_HEIGHT 64
#define OLED_RESET -1 
Adafruit_SSD1306 display(SCREEN_WIDTH, SCREEN_HEIGHT, oledWire, OLED_RESET);

const unsigned char image0_con_meo[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFB, 0xE7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xBD, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0xBB, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF7, 0xFF, 0x7F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF7, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFB, 0x66, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFD, 0xEC, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xEE, 0xDB, 0xBF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF9, 0x67, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xF6, 0xDB, 0xDF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF6, 0x5B, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xD9, 0x66, 0xDF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF7, 0x2A, 0xDF, 0xFF, 0xFF, 0xFF, 0xFF, 0xB5, 0xAD, 0x6F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFD, 0xA6, 0xEF, 0xFF, 0xFF, 0xFF, 0xFC, 0xCD, 0xA5, 0x6F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF4, 0xD5, 0x3F, 0xFF, 0xFF, 0xFF, 0xF7, 0x9B, 0x32, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x51, 0xD9, 0x26, 0x6F, 0xFF, 0x9E, 0x66, 0xDA, 0x9F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFB, 0x9A, 0x5F, 0xFF, 0xFC, 0xCD, 0xF3, 0x32, 0x4D, 0xDF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFD, 0xAB, 0x36, 0xDB, 0xFF, 0xFF, 0x6C, 0x39, 0x27, 0x5F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x64, 0x9B, 0xFE, 0xDA, 0x73, 0xEC, 0xCD, 0xBB, 0x7F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xB4, 0xCD, 0xB7, 0xFC, 0x9E, 0xB2, 0xD2, 0x49, 0xBF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xB3, 0x3F, 0xFD, 0xED, 0x3F, 0x3A, 0x72, 0x64, 0xBF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x59, 0xF6, 0xDF, 0xFD, 0x09, 0xCD, 0x8D, 0x96, 0x7F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xDC, 0x7F, 0xF3, 0xB6, 0x4E, 0xD9, 0xA4, 0x5B, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xA7, 0x5B, 0xFD, 0xFC, 0x13, 0x36, 0x62, 0x6F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xED, 0xFF, 0xED, 0x6D, 0x85, 0x49, 0x19, 0xB7, 0xFF, 0xFF, 0xFF, 0xE7, 
0xFF, 0xFF, 0xFF, 0xFF, 0xDD, 0xBF, 0xFA, 0x6E, 0x00, 0x4B, 0x6C, 0xD4, 0xFF, 0xFF, 0xFE, 0x77, 
0xFF, 0xFF, 0xFF, 0xFF, 0xDF, 0xF6, 0xFB, 0x90, 0x80, 0x26, 0xCF, 0x4F, 0x9F, 0xFF, 0xCB, 0xCF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xBD, 0x90, 0x20, 0x1D, 0xB7, 0xEB, 0x74, 0xFE, 0xBF, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xEF, 0xDF, 0xED, 0x6E, 0x09, 0x5F, 0x78, 0x37, 0x6F, 0xC9, 0xF6, 0xBF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xBF, 0x7E, 0xDF, 0x6F, 0xF6, 0x7B, 0x48, 0x97, 0xBB, 0x7F, 0x79, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x7F, 0xFF, 0xF6, 0xD9, 0x76, 0xFD, 0x98, 0x06, 0xD5, 0xB6, 0xCA, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFB, 0xFF, 0xFF, 0x6F, 0xB7, 0xC9, 0xE6, 0xCB, 0x0F, 0x74, 0xDB, 0xB3, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF7, 0xFD, 0xFF, 0xF9, 0xFE, 0xFB, 0xFA, 0x68, 0x7D, 0x9B, 0x59, 0x8D, 0xFF, 
0xFE, 0x5B, 0xFF, 0xE7, 0xF7, 0xFF, 0xFF, 0x6F, 0x37, 0x99, 0xAF, 0xFF, 0xE9, 0x66, 0x4B, 0xFF, 
0xFB, 0xDD, 0xAF, 0xBF, 0xFF, 0xFD, 0xFF, 0xFB, 0xDF, 0xE5, 0x93, 0xB2, 0x4C, 0x9E, 0x7B, 0xFF, 
0xED, 0xA7, 0xF9, 0x7F, 0xFF, 0xFF, 0xFF, 0xFE, 0xEF, 0x74, 0x52, 0xCC, 0x96, 0xD1, 0x17, 0xFF, 
0xFC, 0xB8, 0xDF, 0xFF, 0xFF, 0xBF, 0xDF, 0x7F, 0xBF, 0x34, 0x1C, 0xFD, 0xB2, 0x64, 0x57, 0xFF, 
0xDB, 0x8E, 0xDF, 0xFF, 0xFF, 0xFF, 0xFD, 0xED, 0xFD, 0xED, 0x87, 0x33, 0x29, 0x9A, 0x5F, 0xFF, 
0xED, 0x63, 0x7F, 0xED, 0xFF, 0xFF, 0xFF, 0xFF, 0x6F, 0x68, 0x27, 0xDE, 0xCC, 0x93, 0x17, 0xFF, 
0xE5, 0x49, 0x6F, 0xFF, 0xFE, 0xF7, 0xFF, 0xB7, 0xBF, 0xEA, 0x49, 0xF6, 0xC6, 0x4D, 0xB7, 0xFF, 
0x76, 0x4C, 0xFF, 0xFB, 0x6F, 0xFF, 0x6E, 0xFD, 0xBD, 0xB6, 0x48, 0x39, 0x31, 0x64, 0x9F, 0xFF, 
0xBB, 0x93, 0xBD, 0xFF, 0xFF, 0xDF, 0xFB, 0xDB, 0x6F, 0xDD, 0xB0, 0x1D, 0x21, 0x22, 0x67, 0xFF, 
0xCC, 0xB6, 0xFF, 0xFD, 0xF7, 0xFD, 0xFF, 0x7E, 0xCE, 0xF1, 0xA3, 0x16, 0x8C, 0x09, 0x77, 0xFF, 
0xF7, 0x2D, 0xF7, 0xBF, 0xDF, 0xBF, 0xB7, 0xCD, 0x9F, 0xBC, 0xA0, 0x1E, 0xD2, 0x49, 0x1F, 0xFF, 
0xFB, 0x6F, 0xFF, 0xFF, 0xFF, 0xFB, 0xFC, 0xF7, 0x37, 0xCD, 0xA0, 0x0B, 0x52, 0x44, 0xDB, 0xFF, 
0xFF, 0x73, 0xBE, 0xF7, 0xFE, 0xFF, 0x6F, 0x76, 0xCD, 0xF6, 0x72, 0x4C, 0x49, 0x32, 0x6B, 0xFF, 
0xFF, 0xDE, 0xFF, 0xBE, 0xFB, 0xEF, 0xF3, 0x59, 0x36, 0xF6, 0x59, 0x3D, 0xA5, 0x92, 0x2B, 0xFF, 
0xFF, 0xEF, 0xED, 0xEF, 0xBF, 0xFB, 0x9E, 0xCD, 0x93, 0xB9, 0x9C, 0x36, 0x24, 0x4C, 0x9B, 0xFF, 
0xFF, 0xF9, 0xBF, 0x7B, 0xFF, 0x7C, 0xFB, 0x30, 0xD9, 0xAC, 0xE7, 0x9A, 0x93, 0x67, 0x5B, 0xFF, 
0xFF, 0xF7, 0xF7, 0x9F, 0xEF, 0xD7, 0x6D, 0x93, 0x0C, 0xE4, 0x2E, 0xCA, 0xD9, 0x11, 0xCF, 0xFF, 
0xFF, 0xFE, 0x5C, 0xF6, 0xFD, 0xF7, 0x66, 0x45, 0x26, 0x73, 0xB3, 0x39, 0x0C, 0xC9, 0xBD, 0xFF, 
0xFF, 0xFB, 0xDB, 0xEF, 0xBF, 0x39, 0x99, 0x64, 0xC9, 0x39, 0x99, 0x26, 0x66, 0xCA, 0x65, 0xFF, 
0xFF, 0xFB, 0x37, 0x3B, 0xF6, 0xEE, 0xDB, 0x3E, 0x49, 0x8C, 0x4C, 0x6C, 0x93, 0x26, 0xDF, 0x7F, 
0xFF, 0xFD, 0xED, 0xDE, 0xDF, 0xFB, 0x66, 0xFB, 0x24, 0xE0, 0xC2, 0x19, 0x99, 0x85, 0x92, 0xBF, 
0xFF, 0xFD, 0x9B, 0x67, 0xFB, 0xCD, 0xFD, 0xDD, 0xA6, 0x72, 0x38, 0x96, 0x6E, 0x10, 0x6C, 0xEF, 
0xFF, 0xFF, 0xF6, 0xBB, 0x7F, 0xB7, 0xBF, 0xF7, 0x93, 0x19, 0x04, 0x64, 0x8B, 0x92, 0x6D, 0xAF, 
0xFF, 0xF7, 0x5C, 0xCF, 0xEF, 0xB7, 0xB7, 0x32, 0xC1, 0x89, 0x21, 0x33, 0x30, 0x09, 0x93, 0x7F, 
0xFF, 0x9F, 0x6F, 0x75, 0xFB, 0x5E, 0xFD, 0xEE, 0xC8, 0x62, 0x49, 0x1B, 0x44, 0x44, 0x36, 0x5F, 
0xFE, 0x7F, 0xA3, 0x35, 0xDE, 0xFF, 0xCF, 0x6D, 0x82, 0x12, 0x44, 0xCC, 0x00, 0x01, 0x2D, 0xDF, 
0xFF, 0xF1, 0xFD, 0x9B, 0xFE, 0xBD, 0xF9, 0xB5, 0x40, 0x91, 0x16, 0x64, 0x00, 0x00, 0xC9, 0xEF, 
0xFF, 0xFF, 0x7C, 0xCE, 0xED, 0xEF, 0x7A, 0x77, 0x40, 0x09, 0x03, 0x38, 0xD3, 0x4C, 0xB7, 0xEF, 
0xFF, 0xFF, 0x3F, 0x65, 0xBD, 0xFB, 0xEF, 0x1A, 0x00, 0x48, 0x49, 0xA2, 0x71, 0xB3, 0x3F, 0xBF, 
0xFF, 0xFF, 0xCF, 0xFD, 0xB7, 0x3F, 0xB9, 0xCC, 0x80, 0x02, 0x2C, 0xC9, 0x0C, 0x24, 0xDF, 0x7F, 
0xFF, 0xFF, 0xF9, 0xBF, 0xFE, 0xED, 0xDF, 0xE4, 0x00, 0x20, 0x86, 0x49, 0x02, 0x01, 0xB6, 0x7F, 
0xFF, 0xFF, 0xFF, 0xCB, 0xEB, 0xB7, 0xC4, 0xB1, 0x00, 0x04, 0x10, 0x04, 0x6F, 0xDE, 0x7B, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x7A, 0x4D, 0xFE, 0x88, 0x02, 0x95, 0x6D, 0xFF, 0xB9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x7E, 0xC9, 0x23, 0x42, 0xFF, 0xFD, 0xEF, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC9, 0xBF, 0xF9, 0x5F, 0xFD, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF6, 0xCD, 0x65, 0x2F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,};

const unsigned char image1_con_chuot[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFB, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x04, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0xFF, 0xC0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x83, 0xFF, 0xF0, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x07, 0xFF, 0xF9, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xFF, 0xFC, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x1F, 0xFF, 0xF8, 0x9F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x4F, 0xFF, 0xF9, 0x0F, 0xFF, 0xFF, 0xFF, 0xC0, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x0F, 0xFF, 0xF1, 0x00, 0xFF, 0xFF, 0xFC, 0x00, 0x0F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xFE, 0x42, 0x3E, 0x00, 0xFF, 0xC0, 0x3F, 0x03, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x2F, 0xF1, 0xA6, 0xFF, 0xFE, 0x0F, 0x00, 0xFF, 0xC1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x87, 0xF7, 0xFF, 0xF7, 0xFF, 0xE0, 0x33, 0xFF, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x83, 0xFF, 0xFF, 0xBD, 0xEF, 0xF8, 0x83, 0xFF, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x19, 0xEF, 0x76, 0xEF, 0x7B, 0xBE, 0x47, 0xFF, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xFF, 0xBD, 0xDF, 0xFF, 0xDE, 0xF7, 0x97, 0xFF, 0xC3, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF8, 0x1F, 0xE3, 0xFF, 0xFF, 0xFB, 0xDD, 0xFF, 0xDF, 0xE3, 0xFF, 0x87, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0x82, 0x07, 0x6D, 0xDB, 0xBE, 0xF7, 0x77, 0x7F, 0x79, 0xFE, 0x0F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF0, 0x7F, 0xFF, 0x7E, 0xF7, 0xBF, 0xDD, 0xF7, 0xFE, 0x78, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF8, 0x1E, 0xDB, 0xF7, 0xC1, 0xFB, 0xFF, 0xDD, 0xEF, 0xE0, 0x3F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF3, 0x47, 0xFF, 0xBF, 0x00, 0x7E, 0xEE, 0xFF, 0x7F, 0xFE, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC0, 0x78, 0xF1, 0xB6, 0xEE, 0x01, 0xEF, 0xBB, 0xEF, 0xDD, 0xBC, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFE, 0x03, 0xFC, 0xFF, 0xFB, 0x00, 0xFB, 0xFF, 0x7B, 0xF7, 0xEE, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC4, 0x7F, 0xDD, 0xDF, 0xCF, 0xDE, 0xF7, 0xF0, 0xFE, 0xF8, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0x1F, 0x03, 0x07, 0x7F, 0xFF, 0x7F, 0xBE, 0xC8, 0x6F, 0xBE, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x7F, 0xBC, 0x73, 0xF6, 0xFB, 0xF7, 0xEF, 0x80, 0xFD, 0xF0, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF8, 0xFD, 0xBE, 0xFB, 0xDF, 0xBE, 0xFD, 0xFB, 0x80, 0xF7, 0xDC, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0xF7, 0x1B, 0xE0, 0xFB, 0xEF, 0xBF, 0x7E, 0xE3, 0xDF, 0x7C, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0xDC, 0xE7, 0x6E, 0xEF, 0x7B, 0xEF, 0xDF, 0xFF, 0xFD, 0xF8, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xCF, 0x79, 0xF7, 0xCC, 0xFD, 0xFF, 0x7B, 0xF7, 0xDF, 0x6F, 0xDC, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9B, 0xF9, 0x0E, 0xFA, 0xDF, 0xED, 0xBE, 0xFD, 0xFD, 0xFB, 0xF6, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0x3E, 0xED, 0xFF, 0xBC, 0xFB, 0xBF, 0xAF, 0x6F, 0x77, 0xBE, 0x00, 0x00, 0x7F, 0xFF, 
0xFF, 0xFF, 0x37, 0xB2, 0x7B, 0xE1, 0xEF, 0x7B, 0x88, 0x7F, 0xDF, 0xEF, 0xFE, 0x7E, 0x03, 0xFF, 
0xFF, 0xFE, 0x5F, 0xF7, 0xBF, 0xFD, 0xFF, 0x0F, 0xE7, 0xF6, 0xFD, 0xFF, 0xFC, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0x3D, 0xFF, 0xFF, 0xFD, 0xB7, 0xE0, 0x1F, 0xDF, 0xEF, 0x76, 0x39, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF8, 0xF7, 0x6F, 0xFF, 0xF9, 0xFD, 0xFF, 0xC0, 0xFD, 0xBF, 0xDF, 0x80, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF2, 0x7F, 0xFD, 0xFF, 0xF3, 0xDF, 0xFF, 0xFF, 0xBF, 0xF6, 0xFB, 0xC4, 0x0F, 0xFF, 0xFF, 
0xFF, 0xF1, 0xEE, 0xDF, 0x6F, 0xC7, 0xF6, 0xFF, 0xFF, 0xF7, 0x7F, 0xE8, 0x27, 0xC1, 0xFF, 0xFF, 
0xFF, 0xE7, 0xFB, 0xF7, 0xFD, 0xFF, 0x7F, 0xBF, 0xFD, 0xDD, 0xED, 0xB7, 0xC7, 0xF8, 0xFF, 0xFF, 
0xFF, 0xCC, 0x7F, 0xBD, 0xB7, 0x7F, 0xDB, 0xFF, 0xEF, 0x7F, 0xFF, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 
0xFF, 0xE1, 0xDD, 0xFF, 0xFF, 0xF6, 0xFF, 0x7E, 0xFB, 0xF7, 0x77, 0x7B, 0x61, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF3, 0xF7, 0xDB, 0xDD, 0xBF, 0xED, 0xEF, 0xBF, 0xBD, 0xDD, 0xEF, 0x9C, 0xFF, 0xFF, 0xFF, 
0xFF, 0xE4, 0xFE, 0xFE, 0xF7, 0xED, 0xBF, 0xFB, 0xEE, 0xFF, 0xFF, 0xFE, 0xCE, 0x3F, 0xFF, 0xFF, 
0xFF, 0xE1, 0xDF, 0xB7, 0xBF, 0x7F, 0xFB, 0xBE, 0xFB, 0xDB, 0xBB, 0xB7, 0x8F, 0x9F, 0xFF, 0xFF, 
0xFF, 0xF2, 0x77, 0xFF, 0xFB, 0xF7, 0x7E, 0xEF, 0xBF, 0xFE, 0xFE, 0xFD, 0xBF, 0xC7, 0xFF, 0xFF, 
0xFF, 0xF2, 0xFD, 0xDB, 0x7E, 0xFD, 0xEF, 0xFB, 0xF7, 0x6F, 0xEF, 0xDF, 0x3D, 0xE3, 0xFF, 0xFF, 
0xFF, 0xF0, 0xEF, 0x7F, 0xDF, 0xBF, 0xFB, 0xBE, 0xDF, 0xFB, 0xBB, 0xF7, 0x77, 0xB3, 0xFF, 0xFF, 
0xFF, 0xFC, 0xFF, 0xF6, 0xF7, 0xEE, 0xDE, 0xF4, 0x7D, 0xBE, 0xFE, 0xFC, 0xDE, 0xF9, 0xFF, 0xFF, 
0xFF, 0xF9, 0xDB, 0xBF, 0xFD, 0xFB, 0xFF, 0xD7, 0xFF, 0xEF, 0xEF, 0xB9, 0xFF, 0xFC, 0xFF, 0xFF, 
0xFF, 0xF9, 0xFE, 0xFB, 0xBF, 0x7F, 0x6D, 0x1F, 0xFE, 0xFD, 0xFB, 0xC7, 0x77, 0x6C, 0xFF, 0xFF, 
0xFF, 0xFC, 0xEF, 0xDE, 0xEF, 0xDD, 0xF1, 0x7F, 0xFF, 0xF7, 0xBE, 0x1F, 0xDD, 0xFC, 0x7F, 0xFF, 
0xFF, 0xFC, 0xFB, 0xF7, 0xFB, 0xF7, 0xCE, 0xFF, 0xFF, 0xFF, 0x9E, 0xFE, 0xFF, 0xDE, 0x7F, 0xFF, 
0xFF, 0xFC, 0x7E, 0xFF, 0x7E, 0xFF, 0x61, 0xB7, 0xFF, 0xFC, 0x7B, 0xFB, 0xEF, 0x7A, 0x7F, 0xFF, 
0xFF, 0xFE, 0x6F, 0xBB, 0xDF, 0xBB, 0xFB, 0xED, 0x9D, 0x87, 0xFF, 0xEF, 0xBD, 0xFE, 0x7F, 0xFF, 
0xFF, 0xFF, 0x3B, 0xEF, 0xF7, 0xEF, 0xFC, 0x0F, 0xCF, 0xBF, 0xB7, 0x7E, 0xF7, 0xDE, 0x7F, 0xFF, 
0xFF, 0xFF, 0x9E, 0xDD, 0xBD, 0xFD, 0xBF, 0xF0, 0x20, 0x3D, 0xFD, 0xDB, 0xDE, 0x62, 0x7F, 0xFF, 
0xFF, 0xFF, 0xF7, 0xF6, 0xCD, 0x36, 0xCB, 0x6F, 0xBE, 0xD6, 0x4D, 0xB6, 0x7B, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,};

const unsigned char image2_con_cho[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE4, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFE, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x33, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0xFE, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x6E, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF9, 0x26, 0x9F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0xCF, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFB, 0x29, 0xE7, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xB3, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0xCF, 0x39, 0xFF, 0xFF, 0xFF, 0xFF, 0xF3, 0x3F, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF4, 0x94, 0xCE, 0x7F, 0xFF, 0xFF, 0xFF, 0xCE, 0xCD, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0x33, 0x66, 0x9F, 0xFF, 0xFF, 0xFE, 0x32, 0x67, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF2, 0x69, 0x31, 0xE7, 0xFF, 0xF4, 0x83, 0xFD, 0xB2, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF5, 0x89, 0x9C, 0x58, 0x00, 0x1F, 0xFD, 0x9D, 0xDD, 0x9F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF1, 0x24, 0x0D, 0x1B, 0xFF, 0xEB, 0x6D, 0xE7, 0x7D, 0xCF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE6, 0xC0, 0x63, 0x26, 0x6D, 0xED, 0xB6, 0x7B, 0xEF, 0x73, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF4, 0x92, 0x3A, 0xC1, 0xB6, 0x76, 0xD6, 0x9A, 0xBB, 0xFC, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0x64, 0x0C, 0x9D, 0xB7, 0x9B, 0x5B, 0xAE, 0xFE, 0xDF, 0x07, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFB, 0x68, 0x05, 0xB6, 0xD9, 0xED, 0xEC, 0xE7, 0xDF, 0xF7, 0xFC, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF8, 0x9A, 0x42, 0x6E, 0xDE, 0x6D, 0xB7, 0x59, 0x77, 0x6D, 0xFF, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF2, 0xB3, 0x09, 0xDB, 0x67, 0xB6, 0xDB, 0x6F, 0x7D, 0xFF, 0x7B, 0xF3, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0x0D, 0xAD, 0xB7, 0x79, 0xB7, 0xFD, 0xA5, 0xBF, 0x9B, 0x48, 0x01, 0xFF, 0xFF, 
0xFF, 0xFF, 0xDD, 0xEC, 0xEF, 0x6D, 0x9A, 0x5D, 0xB7, 0xB4, 0xC0, 0x00, 0x00, 0x01, 0xFF, 0xFF, 
0xFF, 0xFF, 0xDC, 0x26, 0x7B, 0x7B, 0xEF, 0xDB, 0xB4, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 
0xFF, 0xFF, 0xB3, 0x33, 0xB6, 0xDA, 0x64, 0x20, 0x00, 0x00, 0x0F, 0x3C, 0x00, 0x03, 0xFF, 0xFF, 
0xFF, 0xFF, 0x38, 0x9B, 0xDD, 0x80, 0x00, 0x00, 0x00, 0x00, 0x06, 0x63, 0x00, 0x0B, 0xFF, 0xFF, 
0xFF, 0xFF, 0x6C, 0x88, 0x00, 0x00, 0x8E, 0x00, 0x00, 0x07, 0xC0, 0xE2, 0x00, 0x3B, 0xFF, 0xFF, 
0xFF, 0xFF, 0x66, 0x00, 0x00, 0x03, 0xCE, 0x00, 0x00, 0x07, 0xD8, 0x00, 0x01, 0xFC, 0xFD, 0xFF, 
0xFF, 0xFE, 0xD8, 0x57, 0xFF, 0x80, 0x30, 0xE0, 0x00, 0x3D, 0xF8, 0x1F, 0xFF, 0xFF, 0x63, 0xFF, 
0xFF, 0xFE, 0x80, 0xF6, 0xDF, 0xF0, 0x27, 0x1C, 0x00, 0x37, 0x6F, 0xFB, 0xFF, 0xFF, 0x4F, 0xFF, 
0xFF, 0xFE, 0xCF, 0xBB, 0xF6, 0xFE, 0x07, 0x0C, 0x00, 0xDF, 0x7F, 0xEE, 0xEF, 0xFF, 0xBF, 0xFF, 
0xFF, 0xFD, 0xF3, 0x6F, 0x3D, 0xBF, 0xC0, 0x00, 0x17, 0xD9, 0xDD, 0xBF, 0xBF, 0xFF, 0xBF, 0xFF, 
0xFF, 0xFD, 0x3D, 0xDD, 0xEF, 0xB7, 0xE4, 0xFF, 0xFD, 0x6F, 0xF7, 0xB0, 0x45, 0xFF, 0xDF, 0xFF, 
0xFF, 0xFB, 0xCD, 0xB7, 0xFB, 0xFE, 0xFF, 0xB3, 0xEF, 0x7E, 0xFE, 0x41, 0x00, 0x7F, 0xC0, 0x07, 
0xFF, 0xFA, 0xF6, 0xFE, 0xDE, 0xDF, 0xBB, 0xFE, 0xFB, 0xDB, 0xDA, 0x00, 0x00, 0x7E, 0xF7, 0xFF, 
0xFF, 0xF6, 0xF6, 0xDB, 0xF7, 0xF7, 0xEE, 0xDF, 0xBE, 0xFF, 0x7E, 0x00, 0x00, 0x7F, 0xF0, 0x3F, 
0xFF, 0xF7, 0x3B, 0x6F, 0x3D, 0xBD, 0xFF, 0xF7, 0xEF, 0xB7, 0xED, 0x00, 0x02, 0x6F, 0xFB, 0xFF, 
0xFF, 0xED, 0xCD, 0xB5, 0xEF, 0xEF, 0x77, 0x7D, 0xFB, 0x6D, 0xBD, 0x80, 0x00, 0xBE, 0xF9, 0xFF, 
0xFF, 0xCD, 0xF4, 0xDD, 0xBB, 0x7B, 0xDD, 0xDF, 0x7F, 0xFF, 0x66, 0xC0, 0x01, 0x37, 0xF8, 0x1F, 
0xFF, 0xDE, 0x77, 0x6E, 0xDB, 0x7E, 0xFF, 0xF7, 0xB6, 0x96, 0xFB, 0x32, 0x09, 0x5F, 0xFC, 0x4F, 
0xFF, 0xB3, 0x99, 0xB3, 0xF6, 0xCE, 0xDB, 0x7C, 0xED, 0xF6, 0x99, 0x88, 0x88, 0x5B, 0xDB, 0x3F, 
0xFF, 0xBD, 0xBC, 0xDF, 0x3F, 0xF3, 0xDB, 0x5B, 0xDD, 0x6D, 0xEE, 0xC2, 0x22, 0xDF, 0xFB, 0xFF, 
0xFF, 0x6D, 0xA7, 0x59, 0xED, 0xBF, 0x7D, 0xEF, 0x76, 0xDB, 0x6A, 0x20, 0x00, 0x77, 0xF3, 0xFF, 
0xFF, 0x6E, 0x6D, 0xB7, 0xFF, 0xED, 0xB7, 0xB5, 0xB2, 0x13, 0x73, 0x00, 0x05, 0x7E, 0xF7, 0xFF, 
0xFE, 0xDB, 0xDA, 0xB6, 0x66, 0xFE, 0xEE, 0xDD, 0xDD, 0x20, 0x00, 0x04, 0x25, 0xFF, 0xEF, 0xFF, 
0xFE, 0xDA, 0x66, 0xCD, 0xBE, 0xDB, 0xEE, 0xFB, 0x77, 0xAC, 0x84, 0x91, 0x9B, 0xB7, 0xCF, 0xFF, 
0xFD, 0xB6, 0xB5, 0x7B, 0xBB, 0xDD, 0xBB, 0xAE, 0xDE, 0xCB, 0x74, 0xEC, 0xDB, 0xFF, 0x5F, 0xFF, 
0xFD, 0xB5, 0x99, 0x92, 0xCF, 0x77, 0xBB, 0xB6, 0xDB, 0x7B, 0x5B, 0x6E, 0x6E, 0xDF, 0xBF, 0xFF, 
0xFB, 0x6D, 0x6E, 0xEE, 0x75, 0xBE, 0xEE, 0xDB, 0xED, 0xF6, 0xDB, 0xB3, 0xFF, 0xFD, 0xBF, 0xFF, 
0xFB, 0x6E, 0x66, 0x6B, 0xB6, 0xEB, 0xFE, 0xFB, 0x36, 0x9D, 0xB6, 0xFF, 0xB7, 0x6F, 0xBF, 0xFF, 
0xF7, 0xB3, 0x91, 0x99, 0xBB, 0x6F, 0x5B, 0xBD, 0xDB, 0xED, 0xEF, 0x5D, 0xFD, 0xFF, 0xBF, 0xFF, 
0xF4, 0xDD, 0xBD, 0x36, 0x6D, 0xBD, 0xDF, 0xE7, 0x6D, 0x6E, 0x79, 0xF7, 0x5F, 0xB7, 0xDF, 0xFF, 
0xF7, 0xDC, 0xE6, 0xCD, 0xCE, 0xE6, 0xF5, 0x7F, 0x77, 0x73, 0xDF, 0xB6, 0xF6, 0xFD, 0xCF, 0xFF, 
0xF7, 0x67, 0x72, 0xD9, 0xB3, 0x7B, 0x3D, 0xDB, 0xDB, 0x9F, 0x66, 0xDE, 0xFF, 0xDF, 0xEF, 0xFF, 
0xF3, 0xFD, 0x9E, 0x66, 0xBF, 0x9F, 0xCF, 0xBA, 0xDA, 0xED, 0xBB, 0x7B, 0xA9, 0xF6, 0xEF, 0xFF, 
0xFB, 0x9E, 0xED, 0xB6, 0xCC, 0xF6, 0xF2, 0xEE, 0xEE, 0xED, 0xBB, 0xEF, 0xBF, 0x3F, 0xEF, 0xFF, 
0xFB, 0x73, 0xFB, 0xBB, 0x77, 0xDB, 0x7E, 0xCD, 0xB7, 0x36, 0xDE, 0xB4, 0xF7, 0xED, 0xE7, 0xFF, 
0xFD, 0xFF, 0x5E, 0xED, 0x76, 0x7B, 0x5B, 0x73, 0x31, 0xDB, 0x66, 0xDF, 0x6D, 0xFF, 0xB7, 0xFF, 
0xFD, 0xBD, 0xF7, 0xBD, 0x9B, 0xCF, 0xED, 0xBE, 0xCE, 0xD9, 0xBB, 0x6B, 0xDF, 0x77, 0xF7, 0xFF, 
0xFD, 0xCF, 0xBD, 0xF7, 0xEF, 0x7C, 0xEF, 0xED, 0xFB, 0x26, 0x99, 0xBB, 0xB7, 0xDF, 0x77, 0xFF, 
0xFD, 0x7B, 0xEF, 0x7E, 0xFD, 0xF7, 0xBA, 0x7B, 0x6D, 0xBE, 0xE6, 0xDC, 0xFD, 0xFF, 0xE7, 0xFF, 
0xFB, 0xFE, 0x7B, 0xDB, 0xB7, 0x9F, 0x6F, 0x9F, 0xB6, 0xE9, 0xBE, 0xD7, 0xDF, 0x7D, 0xEF, 0xFF, 
0xFA, 0x87, 0xFE, 0xFF, 0xF6, 0x60, 0x41, 0xA5, 0xD2, 0x09, 0x23, 0x77, 0x77, 0xF7, 0xEF, 0xFF, 
0xFC, 0xFD, 0x84, 0x84, 0x59, 0xFF, 0xFF, 0xFC, 0x5F, 0xFF, 0xFD, 0x49, 0x24, 0x16, 0x3F, 0xFF, };

const unsigned char image3_con_trau[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xFF, 
0xFF, 0xFF, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x3F, 
0xFF, 0xFE, 0x6F, 0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0x00, 0x3F, 0xFF, 0xFF, 0xFF, 0xF9, 0x9F, 
0xFF, 0xFC, 0xCF, 0xFF, 0xFF, 0xFF, 0xC0, 0xFF, 0xFF, 0xFF, 0x80, 0xFF, 0xFF, 0xFF, 0xF9, 0x8F, 
0xFF, 0xF9, 0xC7, 0xFF, 0xFF, 0xF8, 0x1F, 0xFF, 0xBD, 0xF7, 0xFA, 0x0F, 0xFF, 0xFF, 0xF9, 0xE7, 
0xFF, 0xF9, 0x71, 0xFF, 0xFF, 0x83, 0xBB, 0x66, 0xE7, 0x5D, 0xEF, 0x60, 0x7F, 0xFF, 0xE3, 0x8F, 
0xFF, 0xF9, 0xFC, 0x3F, 0xE0, 0x7E, 0xE9, 0x7D, 0xFF, 0x7D, 0x2D, 0xBF, 0x03, 0xFF, 0x0F, 0xE7, 
0xFF, 0xF9, 0xBF, 0x80, 0x1F, 0xFD, 0xF7, 0x9D, 0x99, 0xE6, 0xF7, 0xEF, 0xFC, 0x00, 0xFE, 0xCF, 
0xFF, 0xFC, 0x6F, 0xFF, 0xFF, 0xD3, 0x7E, 0xF7, 0xFF, 0xBF, 0x9E, 0xD3, 0xFF, 0xFF, 0xFE, 0x8F, 
0xFF, 0xFE, 0x3B, 0x7F, 0xED, 0xD7, 0x98, 0x3E, 0x6E, 0xFA, 0x33, 0xDB, 0xCF, 0xFF, 0xB7, 0x3F, 
0xFF, 0xFF, 0x87, 0xEE, 0x92, 0x6D, 0xE7, 0x1B, 0xED, 0xCE, 0x5B, 0x7C, 0x70, 0x7B, 0xE8, 0x7F, 
0xFF, 0xFF, 0xF0, 0x08, 0xDE, 0x9F, 0x7C, 0xDF, 0xBD, 0xFC, 0x9F, 0xED, 0x9F, 0x08, 0x03, 0xFF, 
0xFF, 0xFF, 0xFF, 0xE3, 0xFF, 0x9B, 0xDE, 0x35, 0xB7, 0x36, 0x3D, 0xBE, 0x7F, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC7, 0xB6, 0x7E, 0xF3, 0x26, 0xFF, 0xD3, 0x66, 0xD6, 0x6D, 0xF9, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xCC, 0x69, 0x66, 0x8F, 0xFA, 0x40, 0xDF, 0xD9, 0xDF, 0x2D, 0x10, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xCB, 0x08, 0xFD, 0xD8, 0x1B, 0xFF, 0x30, 0x19, 0x7B, 0x80, 0x5D, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0xBD, 0xCC, 0x8C, 0x93, 0x6C, 0x96, 0xED, 0xCF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xE7, 0x67, 0x66, 0xD4, 0xCA, 0xE5, 0xBD, 0xC7, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xDF, 0x65, 0x6B, 0x36, 0xB3, 0x39, 0xEF, 0x67, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0x7B, 0x99, 0x99, 0xA3, 0x35, 0x9A, 0x77, 0x67, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xE8, 0xEE, 0xB6, 0xD6, 0xD9, 0xCC, 0xCE, 0x77, 0x8D, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x01, 0x3D, 0xC6, 0x64, 0x4C, 0x4B, 0x61, 0xDC, 0x80, 0x3F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x1F, 0x93, 0x79, 0x2D, 0x26, 0x72, 0x3F, 0xDB, 0x76, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x26, 0xFA, 0x6F, 0x33, 0xB6, 0x9C, 0xDA, 0x2F, 0xF2, 0x3F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x9B, 0xEF, 0x8D, 0xCC, 0xD9, 0xA5, 0xD3, 0xF9, 0xB8, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC7, 0x7D, 0xF1, 0x69, 0x2D, 0x2F, 0x27, 0x77, 0xC9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0x9D, 0xFE, 0x1B, 0x64, 0xD8, 0x7D, 0xDE, 0x67, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x37, 0x3F, 0xE4, 0x9A, 0x93, 0xDF, 0x7B, 0x1F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x87, 0xE7, 0xFF, 0x8B, 0x7F, 0xED, 0xA0, 0x7F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x7C, 0xDB, 0x7F, 0x6D, 0x3B, 0x87, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xDF, 0xBD, 0x7F, 0xBD, 0xFB, 0xCF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xDB, 0xB6, 0xFF, 0xB7, 0xCE, 0xE3, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0x7B, 0x7E, 0xFF, 0xDE, 0xFE, 0xF3, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xEF, 0x69, 0x98, 0xCB, 0xB7, 0xB1, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCD, 0xBD, 0xEE, 0x66, 0x7E, 0xF7, 0x79, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0x77, 0xBF, 0xFF, 0xED, 0xDD, 0xDC, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9B, 0xDB, 0xB5, 0xBB, 0xBB, 0x7B, 0xDC, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9E, 0xEE, 0xFF, 0xAE, 0xDF, 0xBB, 0x76, 0x7F, 0xE3, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x37, 0x7D, 0xCE, 0xFB, 0x76, 0xEF, 0x76, 0x7F, 0xC8, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3D, 0xDD, 0xFB, 0xDF, 0xF7, 0xDD, 0xDC, 0x7F, 0x08, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9B, 0xB7, 0x3B, 0x74, 0xDD, 0x77, 0xDE, 0x7E, 0x36, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9E, 0xF7, 0xEF, 0x77, 0xDF, 0xEE, 0x76, 0x7C, 0x90, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0x7C, 0xFD, 0xDF, 0x73, 0x3B, 0xF4, 0x7C, 0x4C, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC9, 0xCF, 0x9B, 0xDB, 0x7F, 0xFD, 0xB9, 0x00, 0x40, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xFB, 0xFB, 0x7B, 0xCC, 0xCF, 0xA3, 0xFE, 0x37, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x3E, 0x6F, 0x6E, 0xFF, 0xFA, 0x08, 0x00, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0D, 0xE5, 0xEE, 0xB3, 0x78, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xDB, 0xB0, 0x00, 0x07, 0x6C, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8E, 0xF3, 0xFF, 0xE7, 0xBC, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xD3, 0xFF, 0xF2, 0xE4, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCB, 0x73, 0xFF, 0xF3, 0xF9, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x03, 0xFF, 0xF0, 0x09, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE6, 0xC7, 0xFF, 0xF9, 0xA3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0x27, 0xFF, 0xF8, 0x23, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x0F, 0xFF, 0xFC, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };

const unsigned char image4_con_ho[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0x08, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF8, 0xFF, 0x87, 0xFF, 0xED, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0xF0, 0x40, 0x41, 0x6D, 0x25, 0xFB, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0x84, 0x5B, 0x7F, 0xDB, 0xED, 0x98, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC7, 0x24, 0x00, 0x9E, 0xDB, 0xB2, 0x33, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE6, 0x73, 0xEE, 0xDB, 0x78, 0x7F, 0x83, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE6, 0x0E, 0x01, 0xEC, 0x6E, 0x00, 0xF0, 0x4F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0xE6, 0x7F, 0x3E, 0x37, 0x80, 0x1C, 0x19, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE0, 0xFB, 0xDB, 0xE7, 0x0D, 0xFF, 0x07, 0x0C, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xDF, 0xBB, 0x6C, 0xD9, 0xDB, 0x01, 0xFB, 0xE7, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x39, 0xDD, 0xB7, 0x7E, 0xFF, 0xFC, 0x1E, 0xD3, 0x80, 0x06, 0xD8, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFC, 0xE1, 0xD6, 0xDB, 0x66, 0xEF, 0xFF, 0xC6, 0xDC, 0xE4, 0xFF, 0xFF, 0x1F, 0xFF, 0xFF, 
0xFF, 0xF2, 0xC0, 0x36, 0xDB, 0x9F, 0xF9, 0x03, 0x73, 0x0D, 0x7D, 0x20, 0x7F, 0x8F, 0xFF, 0xFF, 
0xFF, 0x8F, 0x90, 0x3B, 0x6C, 0xFD, 0x9D, 0xFC, 0x3D, 0x87, 0x7B, 0x19, 0x3F, 0x8F, 0xFF, 0xFF, 
0xFE, 0x4F, 0xD3, 0x6D, 0xB7, 0x76, 0x00, 0xFF, 0x9D, 0x84, 0xF8, 0xC4, 0xBF, 0x1F, 0xFF, 0xFF, 
0xF9, 0x9B, 0xF9, 0xCD, 0xB7, 0x6C, 0x00, 0xF3, 0x9E, 0xED, 0xFC, 0x24, 0xF4, 0x3F, 0xFF, 0xFF, 
0xF9, 0x8C, 0xAF, 0x7B, 0x6D, 0xD9, 0x80, 0x01, 0xBE, 0xEB, 0xD9, 0x27, 0xF0, 0xFF, 0xFF, 0xFF, 
0xF8, 0xE6, 0xBD, 0xBB, 0x6C, 0x1C, 0x98, 0x09, 0x73, 0x33, 0xD2, 0x7F, 0x03, 0xFF, 0xFF, 0xFF, 
0xF8, 0x77, 0x66, 0xCC, 0xB6, 0x27, 0x18, 0x26, 0x47, 0x36, 0xF6, 0xD0, 0x7F, 0xFF, 0xFF, 0xFF, 
0xF8, 0x7F, 0x98, 0x77, 0xF7, 0x7F, 0xE6, 0x93, 0xDC, 0x4F, 0xE0, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFC, 0x17, 0xFF, 0xFF, 0xFD, 0xDF, 0xFF, 0xFF, 0xB0, 0xDB, 0xEF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xCD, 0xAF, 0xCF, 0xFE, 0xF6, 0xFF, 0xFC, 0x03, 0x39, 0xE7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFE, 0xFB, 0xA1, 0xFD, 0xFF, 0x36, 0x99, 0x01, 0x6D, 0xE3, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x3F, 0xDE, 0x77, 0x47, 0xC9, 0xCF, 0x7F, 0x6C, 0x8F, 0xDF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xC6, 0xDB, 0x9B, 0x1F, 0xFF, 0x64, 0xD3, 0xB8, 0x1F, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0xF6, 0xED, 0xFE, 0xFF, 0xBF, 0xFC, 0x01, 0xFA, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x7F, 0xFF, 0xFD, 0xFE, 0xD0, 0x00, 0x5F, 0xE3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0xFF, 0xF7, 0xF7, 0xFF, 0xFF, 0xFF, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF1, 0xB3, 0x73, 0xDF, 0xFF, 0xFF, 0xA3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFE, 0xFF, 0xDE, 0x7A, 0x04, 0x82, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x7F, 0xFF, 0xE0, 0x06, 0xF8, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFB, 0x1F, 0xE0, 0x06, 0x71, 0x2E, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0x8C, 0x0F, 0xFE, 0x07, 0xE8, 0x31, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC3, 0xF3, 0xFF, 0x80, 0x39, 0xB0, 0xB4, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x98, 0xFF, 0xF0, 0x3D, 0xCE, 0x81, 0xCC, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x7F, 0x7F, 0x8F, 0xFB, 0x76, 0x1F, 0x60, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x1F, 0xFE, 0x7F, 0xC2, 0x73, 0xFF, 0x03, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF9, 0x9F, 0xFF, 0xFC, 0x0C, 0xCE, 0xE4, 0x9D, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0xE3, 0xFF, 0xE0, 0xFD, 0xB9, 0x00, 0x76, 0x40, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0xE8, 0xFF, 0xCF, 0xFD, 0x80, 0x1F, 0xDB, 0x63, 0xEF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0x9F, 0xFF, 0x3F, 0xF8, 0x64, 0xF6, 0xD9, 0xA6, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x83, 0xFF, 0xFF, 0xFB, 0x1F, 0xB6, 0x86, 0x9D, 0x84, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x01, 0xFF, 0xFF, 0x6C, 0xDB, 0x68, 0x36, 0xC8, 0x39, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x7E, 0x77, 0xFB, 0xFC, 0xED, 0x01, 0xD9, 0x63, 0xC6, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x26, 0x9F, 0x7F, 0xF0, 0xA4, 0x1D, 0x00, 0x0C, 0x00, 0xDF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x90, 0x9D, 0xF7, 0xC3, 0x80, 0xE4, 0x26, 0xD0, 0x0F, 0x67, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xD4, 0x00, 0xFF, 0x3F, 0x8B, 0x83, 0xFB, 0x73, 0x71, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xCF, 0xE8, 0x1F, 0xFF, 0xFA, 0x7E, 0x59, 0x0C, 0xD4, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC8, 0x2F, 0x87, 0xFF, 0xE7, 0x60, 0x04, 0xD9, 0x9F, 0xBD, 0xB3, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC9, 0x00, 0xF1, 0xED, 0xF5, 0x99, 0x24, 0x07, 0x60, 0x00, 0x09, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC0, 0x00, 0x0C, 0xFF, 0xD4, 0xFF, 0xFF, 0xF3, 0x3F, 0xC2, 0x49, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xBF, 0xF3, 0x02, 0x3F, 0x73, 0x00, 0x00, 0x5B, 0x9B, 0x7F, 0xFB, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xB6, 0x00, 0x7F, 0x9B, 0xF8, 0x04, 0xFD, 0x86, 0xC0, 0x00, 0x03, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x00, 0xFE, 0x00, 0xBB, 0x39, 0xF6, 0x03, 0xB6, 0x7F, 0x90, 0x07, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0xC9, 0x03, 0xD0, 0xFD, 0xEC, 0x13, 0x7E, 0x73, 0x00, 0xFF, 0xEF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0x1F, 0x68, 0x7F, 0xFC, 0xEC, 0x08, 0x41, 0x9E, 0x90, 0x04, 0x9F, 0xFF, 0xFF, 0xFF, 
0xFD, 0xF7, 0x60, 0x3F, 0x23, 0x6E, 0x3F, 0xFF, 0xFF, 0xA4, 0xFF, 0xF6, 0x06, 0x82, 0x05, 0xBF, 
0xDF, 0xFF, 0xF6, 0x83, 0x9D, 0xEF, 0x80, 0xB6, 0xB6, 0xE7, 0xFF, 0xFF, 0x84, 0x83, 0x8C, 0x03, 
0xB3, 0xDF, 0xFD, 0xEC, 0xEB, 0x79, 0xFC, 0xB6, 0xDB, 0x3B, 0x75, 0xDB, 0xFF, 0xFF, 0xFE, 0x7D, 
0xBF, 0xEF, 0xFE, 0x6C, 0xEF, 0x77, 0x77, 0xFF, 0xEF, 0xFE, 0x7D, 0xFB, 0xFF, 0xFF, 0xFF, 0x05, 
0xB7, 0xBF, 0xFF, 0x33, 0xB4, 0xDD, 0x93, 0x7E, 0xFE, 0xFD, 0xEF, 0x9F, 0xBF, 0xFF, 0xE3, 0xC3, 
0xD2, 0x24, 0x93, 0x1F, 0xFF, 0xFF, 0xF6, 0xDE, 0xFF, 0xED, 0xB2, 0xE4, 0x69, 0xE0, 0xE0, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF7, 0xFF, 0xF7, 0x6F, 0x3F, 0xFE, 0x48, 0x00, 0x1F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0xA9, 0xCD, 0x99, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };

const unsigned char image5_con_rong[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x05, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x1F, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0xFE, 0xDB, 0x11, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCB, 0xFB, 0xE0, 0x08, 0x07, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0x80, 0x0D, 0xEF, 0x20, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x30, 0x36, 0x3F, 0xFF, 0xFC, 0x3F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x87, 0xF1, 0xF6, 0xFD, 0xFF, 0x9F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x1D, 0xC8, 0x00, 0x07, 0xEE, 0x4F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0x40, 0x09, 0xEF, 0xB0, 0x79, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x4F, 0xC4, 0x3F, 0xFF, 0x1B, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x23, 0xE5, 0x83, 0x7F, 0xE3, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x88, 0x70, 0x78, 0xF6, 0x3F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x96, 0x32, 0x7E, 0x79, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0x99, 0x1F, 0x9B, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xC1, 0x8F, 0xE7, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xA1, 0xF4, 0xE7, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCE, 0x08, 0x70, 0xE6, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8C, 0x06, 0xF2, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xDF, 0xFF, 0xF3, 0x0C, 0x90, 0xE4, 0xF9, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x2F, 0xE7, 0xE0, 0x40, 0x88, 0x09, 0x81, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0xCF, 0xD8, 0x40, 0xD2, 0x62, 0x20, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFD, 0xDF, 0xD8, 0x1A, 0x12, 0x09, 0x24, 0x20, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF9, 0x9F, 0xB4, 0x82, 0x49, 0x24, 0x12, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x02, 0x12, 0x74, 0xA4, 0x89, 0x24, 0xC9, 0x92, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x81, 0x22, 0x40, 0x62, 0x24, 0xA0, 0x92, 0x08, 0x04, 0x8F, 0xFF, 0xFF, 0xFF, 0x81, 
0xFF, 0xFF, 0xD1, 0x2C, 0x4D, 0x09, 0x12, 0x16, 0x42, 0x62, 0x60, 0x0F, 0xFF, 0xFF, 0xF8, 0x24, 
0xFF, 0xFF, 0xEF, 0xFE, 0x3E, 0x11, 0x49, 0xD9, 0x19, 0x09, 0x19, 0x3F, 0xFF, 0xFF, 0xE0, 0x91, 
0xFF, 0xFF, 0xF0, 0x13, 0x7E, 0xC4, 0x6F, 0xDF, 0xF1, 0x24, 0x80, 0x47, 0xFF, 0xFF, 0xF2, 0x07, 
0xFF, 0xFF, 0xFF, 0x90, 0x47, 0x32, 0x3B, 0x21, 0xEE, 0x44, 0x96, 0x50, 0xFF, 0xFF, 0xF0, 0x5F, 
0xFF, 0xFF, 0xFF, 0x14, 0xC7, 0x1E, 0x80, 0x7E, 0x1F, 0x92, 0x40, 0x00, 0x7F, 0xFF, 0xC0, 0x3F, 
0xFF, 0xFF, 0xFE, 0x49, 0x38, 0x47, 0xE6, 0x07, 0x43, 0x48, 0x49, 0x23, 0xFF, 0xFF, 0xC6, 0x7F, 
0xFF, 0xFF, 0xC0, 0xA2, 0x02, 0x41, 0x18, 0x80, 0xA1, 0xE5, 0x09, 0x07, 0xFF, 0xFF, 0x87, 0xFF, 
0xFF, 0xFF, 0x12, 0x24, 0xC9, 0x30, 0xF6, 0x31, 0xA4, 0xF1, 0x24, 0xC0, 0x1F, 0xFE, 0x27, 0xFF, 
0xFF, 0xFE, 0x49, 0x11, 0x04, 0x08, 0xFA, 0x64, 0x24, 0x12, 0x44, 0x12, 0x4F, 0xFE, 0x27, 0xFF, 
0xFF, 0xFE, 0x48, 0x49, 0x38, 0x41, 0xF8, 0x80, 0x59, 0x08, 0x92, 0x40, 0x1F, 0xFF, 0x07, 0xFF, 
0xFF, 0xFE, 0x26, 0x22, 0x70, 0x33, 0xFE, 0x3F, 0xDB, 0x62, 0x09, 0x29, 0x7F, 0xFE, 0x57, 0xFF, 
0xFF, 0xFF, 0x00, 0x86, 0xE7, 0x07, 0xFF, 0xFF, 0xDF, 0xF1, 0x21, 0x24, 0x0F, 0xFC, 0x43, 0xFF, 
0xFF, 0xFF, 0x32, 0x64, 0x3C, 0x9F, 0xFF, 0xFF, 0x9F, 0xFC, 0x14, 0x90, 0xE0, 0xFF, 0x23, 0xFF, 
0xFF, 0xFF, 0x83, 0x0D, 0x1C, 0x1F, 0xFF, 0xFF, 0xB3, 0x6E, 0xC4, 0x8A, 0x00, 0xFF, 0xA1, 0xFF, 
0xFF, 0xFF, 0xC5, 0x7D, 0x71, 0x3F, 0xFF, 0xFF, 0xBC, 0x9A, 0x26, 0x22, 0x13, 0xFE, 0x19, 0xFF, 
0xFF, 0xFF, 0xFE, 0x62, 0x70, 0x7F, 0xFF, 0xFF, 0x7F, 0xFF, 0x30, 0xC9, 0x44, 0xFF, 0x10, 0xFF, 
0xFF, 0xFF, 0x38, 0x1E, 0xCC, 0xFF, 0xFF, 0xFF, 0x77, 0xF5, 0x84, 0x11, 0x04, 0x3F, 0xC4, 0x7F, 
0xFF, 0xFC, 0x41, 0xF5, 0xC1, 0xFF, 0xFF, 0xFE, 0x6D, 0xB0, 0x25, 0x24, 0xB1, 0x1F, 0x48, 0x7F, 
0xFF, 0xFC, 0x53, 0x64, 0x33, 0xFF, 0xFF, 0xFC, 0xDB, 0x3C, 0x91, 0x24, 0x08, 0xFF, 0x12, 0x7F, 
0xFF, 0xFF, 0x9D, 0x90, 0x07, 0xFF, 0xFF, 0xF8, 0xFF, 0xE2, 0x48, 0x91, 0x40, 0xFF, 0x92, 0x3F, 
0xFF, 0xC2, 0x2D, 0xD7, 0xFF, 0xFF, 0xFF, 0xFA, 0x7D, 0xF9, 0x26, 0x12, 0x56, 0x0F, 0x08, 0xBF, 
0xFF, 0x99, 0x3E, 0x47, 0xFF, 0xFF, 0xFF, 0xF9, 0x77, 0xC9, 0x10, 0xC4, 0x80, 0x26, 0x48, 0x3F, 
0xFF, 0x8F, 0xDB, 0x17, 0xFF, 0xFF, 0xFF, 0xF9, 0x5E, 0xE4, 0x44, 0x24, 0x29, 0x0C, 0x12, 0x3F, 
0xFF, 0x42, 0xF3, 0x27, 0xFF, 0xFF, 0xFF, 0xFA, 0x6A, 0xB1, 0x25, 0x09, 0x24, 0x7E, 0x44, 0x7F, 
0xF8, 0x37, 0xBC, 0x7F, 0xFF, 0xFF, 0xFF, 0xF8, 0xBF, 0xF9, 0x21, 0x42, 0x44, 0x9C, 0x91, 0x7F, 
0xF9, 0xBD, 0x8B, 0x3F, 0xFF, 0xFF, 0xFF, 0xFD, 0x1D, 0xDC, 0x98, 0x42, 0x49, 0x01, 0x20, 0x7F, 
0xFC, 0x6E, 0xE0, 0xBF, 0xFF, 0xFF, 0xFF, 0xFE, 0x5F, 0xF6, 0x06, 0x31, 0x12, 0x49, 0x24, 0xFF, 
0xF9, 0x6B, 0x51, 0x7F, 0xFF, 0xFF, 0xFF, 0xFE, 0x0E, 0xED, 0x61, 0x84, 0x44, 0x92, 0x01, 0xFF, 
0xF3, 0x69, 0x44, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x23, 0x3F, 0x90, 0x10, 0x48, 0x24, 0x93, 0xFF, 
0xE4, 0xC4, 0xAF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCC, 0x81, 0xF3, 0xE6, 0x49, 0x03, 0x20, 0x07, 0xFF, 
0x25, 0x90, 0x8F, 0xFF, 0xFF, 0xFF, 0xFF, 0xC7, 0x34, 0xC0, 0x38, 0x88, 0x20, 0x09, 0x1F, 0xFF, 
0xE3, 0x2C, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xED, 0x64, 0x39, 0x02, 0x24, 0x88, 0x80, 0x7F, 0xFF, 
0xEA, 0x4F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0xE1, 0x6E, 0x49, 0x20, 0x82, 0x07, 0xFF, 0xFF, 
0xC9, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xEE, 0x80, 0x0E, 0x49, 0x11, 0xFF, 0xFF, 0xFF, 0xFF, 
0xC4, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x7F, 0xD1, 0xE0, 0x47, 0xFF, 0xFF, 0xFF, 0xFF, 
0xD7, 0xEF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xDD, 0xA0, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xCF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };

const unsigned char image6_con_ran[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x92, 0xC8, 0x00, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0x00, 0x00, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x6D, 0x37, 0xFF, 0x81, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x07, 0xB7, 0xD9, 0x99, 0xE0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x19, 0xB4, 0xDE, 0x66, 0x78, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x36, 0x6D, 0x33, 0xEE, 0x9C, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x67, 0x9B, 0xCC, 0x99, 0xCF, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xD9, 0xD6, 0x77, 0x77, 0x72, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x9E, 0x75, 0xB5, 0x64, 0x1B, 0x87, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xB0, 0x2D, 0xBF, 0x98, 0x1B, 0xC0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xE1, 0x68, 0x2F, 0xFF, 0xFC, 0x1F, 0xF8, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x83, 0xE8, 0x3F, 0x7F, 0x3F, 0xFF, 0xFC, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xFF, 0xFE, 0x7F, 0x3F, 0xFF, 0xFE, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x3F, 0xFF, 0xFF, 0xF7, 0xFF, 0x8F, 0xFE, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x1F, 0xFC, 0x7E, 0x00, 0x02, 0x0F, 0xF8, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0xFC, 0x00, 0x00, 0x40, 0x7F, 0xE0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x87, 0xFF, 0x93, 0xCC, 0x7F, 0xFF, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0xFF, 0xFF, 0xC6, 0x7F, 0xF8, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x0F, 0xFF, 0xC0, 0x3E, 0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0x00, 0x00, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x09, 0x00, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0xDD, 0x83, 0xFE, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0xF6, 0x07, 0xFE, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0xDB, 0xC7, 0xFE, 0x18, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0x99, 0x07, 0xFE, 0x1A, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x3F, 0xB7, 0x07, 0xFE, 0x2D, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x3F, 0xCC, 0x8F, 0xF8, 0x35, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0x08, 0x7F, 0x68, 0x8F, 0xE0, 0xD6, 0x00, 0x3F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0xFF, 0x22, 0x00, 0x01, 0x00, 0x00, 0x07, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0xF0, 0xFE, 0xF2, 0x00, 0x00, 0x03, 0xFC, 0x83, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xE0, 0xCA, 0x59, 0xEE, 0xD9, 0x8B, 0xFC, 0xB2, 0x5B, 0x20, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC3, 0xA2, 0x61, 0xFE, 0x9E, 0x03, 0x26, 0x0B, 0xCE, 0x68, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0x86, 0xBD, 0xB3, 0xFE, 0xE7, 0x16, 0xDB, 0x4C, 0xB3, 0xD8, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0x86, 0xD5, 0x93, 0xFE, 0xB5, 0x8C, 0xDB, 0xF6, 0xED, 0x30, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC5, 0x76, 0xE3, 0xFE, 0xD9, 0x07, 0x66, 0x33, 0x35, 0xA0, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x00, 0x02, 0x63, 0xFD, 0x4E, 0x40, 0x79, 0xCC, 0x00, 0x00, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0x00, 0x00, 0x03, 0xB7, 0x76, 0x20, 0x00, 0x00, 0x48, 0x1C, 0x07, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC1, 0xE6, 0x7F, 0x03, 0xFE, 0xD3, 0x2F, 0x80, 0x07, 0xF2, 0x97, 0xC3, 0xFF, 0xFF, 
0xFF, 0xFF, 0x87, 0x31, 0x33, 0xE3, 0xFF, 0x9D, 0xD9, 0xFD, 0xB4, 0x98, 0x99, 0x61, 0xFF, 0xFF, 
0xFF, 0xFF, 0x0C, 0xD9, 0x9C, 0xA1, 0xFF, 0xEC, 0xD6, 0x58, 0x1B, 0xBF, 0x6F, 0x30, 0xFF, 0xFF, 
0xFF, 0xFF, 0x13, 0xCE, 0xE6, 0xD8, 0xFF, 0xEB, 0x36, 0xCF, 0xCE, 0x65, 0x64, 0xD8, 0xFF, 0xFF, 
0xFF, 0xFF, 0x1E, 0x76, 0x6E, 0x70, 0x7F, 0xBB, 0xEB, 0x34, 0xF3, 0xD9, 0xBD, 0xF8, 0xFF, 0xFF, 
0xFF, 0xFF, 0x09, 0x99, 0xB3, 0x9C, 0x3E, 0xFE, 0x9B, 0xF7, 0x36, 0x5E, 0xDB, 0xF8, 0xFF, 0xFF, 
0xFF, 0xFF, 0x0F, 0x6F, 0x9C, 0xE7, 0x0F, 0xFF, 0xFC, 0xCD, 0x9D, 0xE7, 0xFF, 0xF0, 0xFF, 0xFF, 
0xFF, 0xFF, 0x8F, 0xEC, 0xEF, 0x7F, 0xC1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xC1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC0, 0xFF, 0xFB, 0xFF, 0xF0, 0x3F, 0xF7, 0xFF, 0xFF, 0xFF, 0xFE, 0x07, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0x07, 0xFF, 0xFF, 0xBF, 0x00, 0xFF, 0xFF, 0xDF, 0xFE, 0x80, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x01, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFC, 0x00, 0x00, 0x04, 0xFF, 0x00, 0x00, 0x00, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };

const unsigned char image7_con_lon[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x91, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x21, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x69, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFE, 0x03, 0xFF, 0xFF, 0xFF, 0xFC, 0xC9, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0xE8, 0xFF, 0xFF, 0xFF, 0xF9, 0x93, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC6, 0x18, 0xFF, 0xFF, 0xFF, 0xF3, 0x23, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x10, 0xC4, 0xFF, 0xFF, 0xFF, 0xF6, 0x63, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0x47, 0xC8, 0xFF, 0xFF, 0xFF, 0xE4, 0xC6, 0x04, 0x6F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xE0, 0x1F, 0xC8, 0xFF, 0xFF, 0xFF, 0xE5, 0x80, 0x01, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x00, 0x7F, 0xC8, 0xFF, 0xFF, 0xFF, 0xE6, 0x21, 0x18, 0x81, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFC, 0x00, 0xFF, 0xC8, 0xFF, 0xFF, 0xFF, 0xF3, 0x8C, 0x00, 0x11, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF0, 0x00, 0xFF, 0xC9, 0xFF, 0xFF, 0xFF, 0x81, 0x66, 0x00, 0x02, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xE0, 0x00, 0xFF, 0x91, 0xFF, 0xFF, 0xFF, 0x00, 0x90, 0x00, 0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xC0, 0x00, 0x7F, 0x91, 0xFF, 0xFF, 0xFE, 0x1E, 0x20, 0xF0, 0x01, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xC0, 0x00, 0xFF, 0x11, 0xFF, 0xFF, 0xFC, 0xD2, 0x0E, 0x08, 0x00, 0x7F, 0xE4, 0x00, 0xFF, 0xFF, 
0xE0, 0x03, 0xFF, 0x23, 0xFF, 0xF3, 0xFC, 0x6D, 0xD1, 0x30, 0x08, 0xFE, 0x01, 0x61, 0xFF, 0xFF, 
0xE0, 0x03, 0xFE, 0x2B, 0xFF, 0xF0, 0x20, 0xA8, 0x55, 0xBD, 0x82, 0x78, 0x9B, 0x0F, 0xFF, 0xFF, 
0xE0, 0x07, 0xFE, 0x43, 0xFF, 0xFC, 0x00, 0xB6, 0x04, 0xCC, 0xF9, 0x01, 0x30, 0xFF, 0xFF, 0xFF, 
0xE0, 0x07, 0xFC, 0x53, 0xFF, 0xF0, 0x00, 0x57, 0x8B, 0x67, 0xF0, 0x84, 0x47, 0xFF, 0xFF, 0xFF, 
0xF9, 0x0F, 0xFC, 0xC3, 0xFF, 0x82, 0x01, 0x58, 0xC9, 0x3F, 0xCE, 0xC0, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF8, 0x0F, 0xF9, 0x03, 0xFF, 0xC0, 0x04, 0x4B, 0x21, 0xBF, 0xC9, 0x27, 0xFF, 0xFC, 0x07, 0xFF, 
0xFC, 0x3F, 0xF9, 0x23, 0xF0, 0x00, 0x24, 0xB4, 0x88, 0xFF, 0x23, 0x60, 0x35, 0x03, 0xF3, 0x1F, 
0xFE, 0x1F, 0xF8, 0x88, 0x20, 0x22, 0x93, 0x36, 0xC7, 0xFD, 0x09, 0x9E, 0x80, 0x7F, 0xF9, 0x4F, 
0xFF, 0x1F, 0xF0, 0xB2, 0x80, 0x08, 0x93, 0x4A, 0x63, 0xFE, 0x4C, 0xF3, 0x6F, 0xFF, 0xED, 0x67, 
0xFF, 0xFF, 0x86, 0xDA, 0xDD, 0x92, 0x4C, 0xDB, 0x23, 0xFB, 0xE3, 0x2D, 0x6F, 0xFF, 0x74, 0x73, 
0xFF, 0xFE, 0x2B, 0x4D, 0x44, 0xD2, 0x4B, 0x35, 0x87, 0xEE, 0xE0, 0x99, 0xBB, 0x1B, 0xDC, 0xF3, 
0xFF, 0xF8, 0xEB, 0x65, 0x72, 0x49, 0x33, 0x64, 0xE3, 0x36, 0xB8, 0x93, 0xF8, 0x1F, 0xC7, 0xBB, 
0xFF, 0xE3, 0x34, 0xBD, 0x9B, 0x24, 0x94, 0xDB, 0x21, 0xF7, 0xB2, 0x4F, 0xC0, 0xFD, 0x96, 0xF3, 
0xFF, 0x8D, 0x95, 0xA6, 0xCC, 0x84, 0x9D, 0x9B, 0x60, 0x3D, 0xC9, 0x3E, 0xE6, 0xEF, 0x1E, 0xD7, 
0xFF, 0x2C, 0xC5, 0x6A, 0x66, 0x49, 0x23, 0x66, 0xD0, 0x00, 0x01, 0x33, 0xA7, 0xFB, 0x5D, 0xC7, 
0xFF, 0x33, 0x19, 0x5B, 0x73, 0x09, 0x2C, 0xD9, 0x94, 0x80, 0x04, 0x6D, 0xB9, 0x9B, 0x3C, 0x1F, 
0xFE, 0x58, 0x66, 0xD6, 0x99, 0x24, 0x93, 0x36, 0x64, 0xB0, 0x10, 0x1C, 0xCE, 0x64, 0xE8, 0xFF, 
0xFE, 0x4C, 0x96, 0xB4, 0xED, 0x84, 0x49, 0xA6, 0xD9, 0xDD, 0x82, 0x02, 0x77, 0xDF, 0xC3, 0xFF, 
0xFE, 0x61, 0x99, 0xAD, 0xA6, 0x43, 0x0C, 0xDB, 0x33, 0x74, 0xE0, 0x81, 0x00, 0x10, 0x1F, 0xFF, 
0xFE, 0x32, 0x66, 0x6F, 0x3B, 0x48, 0x22, 0x59, 0xAC, 0xFE, 0x78, 0x91, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFE, 0x09, 0x26, 0xD2, 0xD9, 0x82, 0x93, 0x26, 0xCC, 0x9B, 0xD8, 0x44, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x41, 0x99, 0xBA, 0xD6, 0x60, 0x84, 0xB6, 0x73, 0x37, 0xD9, 0x20, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x32, 0x5B, 0x2E, 0xDB, 0x2C, 0x20, 0x91, 0x96, 0xCD, 0x69, 0x32, 0x7F, 0xFF, 0xFF, 0xFF, 
0xFE, 0x08, 0xC6, 0xD3, 0x2D, 0x83, 0x09, 0x0C, 0x92, 0xC9, 0x22, 0x4A, 0x3F, 0xFF, 0xFF, 0xFF, 
0xFE, 0x44, 0x92, 0xDD, 0xE5, 0xF0, 0xC1, 0x22, 0x69, 0x32, 0xFC, 0xC9, 0x9F, 0xFF, 0xFF, 0xFF, 
0xFF, 0x30, 0x64, 0xA4, 0x9C, 0x5C, 0x30, 0x22, 0x09, 0x36, 0xFC, 0x35, 0x0F, 0xFF, 0xFF, 0xFF, 
0xFE, 0x22, 0x2D, 0x37, 0x73, 0x97, 0x0C, 0x88, 0x92, 0x4D, 0x9B, 0x14, 0xC7, 0xFF, 0xFF, 0xFF, 
0xF8, 0xC8, 0x11, 0x59, 0x4C, 0xE5, 0x80, 0x01, 0x00, 0x00, 0x66, 0xCA, 0x63, 0xFF, 0xFF, 0xFF, 
0xF3, 0x04, 0x86, 0x49, 0x92, 0x39, 0xA6, 0x51, 0x24, 0x92, 0x04, 0x23, 0x13, 0xFF, 0xFF, 0xFF, 
0xF3, 0x31, 0xE2, 0x86, 0x66, 0x8E, 0x48, 0x44, 0x04, 0x00, 0x91, 0x00, 0x07, 0xFF, 0xFF, 0xFF, 
0xF8, 0x87, 0xF0, 0xB0, 0x08, 0x13, 0x42, 0x24, 0x91, 0x64, 0x10, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF9, 0x0F, 0xFC, 0x09, 0x91, 0x1B, 0x30, 0x89, 0x20, 0x05, 0x41, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF9, 0x4F, 0xFF, 0x08, 0x44, 0x4C, 0xC8, 0x00, 0x4E, 0x98, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF9, 0x1F, 0xFF, 0x86, 0x00, 0x0D, 0x82, 0x26, 0x40, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF8, 0x3F, 0xFF, 0xF0, 0x33, 0x26, 0x24, 0xD0, 0x11, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF2, 0x3F, 0xFF, 0xFE, 0x04, 0x1B, 0x68, 0x12, 0x14, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF3, 0x3F, 0xFF, 0xFF, 0x91, 0x80, 0x02, 0x23, 0x90, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF1, 0x3F, 0xFF, 0xFF, 0x98, 0xE0, 0xFE, 0x03, 0x8C, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF8, 0x8F, 0xFF, 0xFF, 0xC4, 0x1F, 0xFC, 0x13, 0xC8, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF8, 0x03, 0xFF, 0xFF, 0xE4, 0x03, 0xF8, 0x07, 0xE2, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xF8, 0x01, 0xFF, 0xFF, 0xF0, 0x01, 0xF8, 0x07, 0xE4, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFE, 0x11, 0xFF, 0xFF, 0xFE, 0x41, 0xF8, 0x1F, 0xF3, 0x1B, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x81, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x80, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x00, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };

const unsigned char image8_con_ngua[] PROGMEM = {0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x97, 0x00, 0x01, 0xCF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3B, 0x80, 0xF8, 0x00, 0x07, 0xCF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0x0B, 0x1F, 0xF0, 0x07, 0x87, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x90, 0x09, 0xFF, 0xFF, 0x08, 0x4F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFB, 0x80, 0x8F, 0xFF, 0xFE, 0x8E, 0x8F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x27, 0x3F, 0xFF, 0xFF, 0xBE, 0x01, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x84, 0xFC, 0xFF, 0xFC, 0x07, 0xE3, 0x03, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x03, 0xF9, 0xFF, 0xFC, 0x77, 0xF1, 0x07, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xC7, 0xFF, 0xF0, 0x0F, 0x70, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC7, 0x3F, 0xFF, 0xC3, 0x0F, 0x49, 0x1F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8C, 0xFF, 0xFC, 0xC4, 0x1E, 0x19, 0x1F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x05, 0xF1, 0xE0, 0x84, 0x1E, 0xF8, 0x1F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x93, 0xFD, 0xF1, 0x04, 0x1F, 0xF8, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC7, 0xFC, 0xF7, 0x0C, 0x0F, 0x5C, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0xFE, 0x7E, 0x0C, 0x27, 0x7C, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 0xFF, 0x70, 0x1C, 0x30, 0xFC, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x17, 0xFF, 0xF0, 0x18, 0x38, 0xFC, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x67, 0xFF, 0xF8, 0x18, 0x3C, 0x76, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xE1, 0xFF, 0xF8, 0x10, 0x1E, 0x74, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xF8, 0x7F, 0xF8, 0x10, 0x1E, 0x6E, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xFE, 0x7F, 0xF8, 0x00, 0x1F, 0x22, 0x3F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x7F, 0xFE, 0x7F, 0xE4, 0x00, 0x1F, 0x38, 0x7F, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x03, 0xFF, 0xFE, 0x3F, 0xFF, 0x00, 0x0F, 0x00, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE1, 0xFF, 0xFF, 0xFE, 0x3E, 0xFF, 0xC0, 0x0F, 0xF7, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x01, 0x8F, 0xFF, 0xFF, 0xFE, 0x3E, 0xF3, 0xE0, 0x07, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xFC, 0x3E, 0x7F, 0xFF, 0xFE, 0x1E, 0xFE, 0xBE, 0x03, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0x00, 0x7C, 0xFF, 0xFF, 0xFE, 0x1F, 0xF2, 0xFF, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x70, 0x01, 0xFC, 0xFF, 0xFF, 0xFE, 0x0F, 0xFF, 0xFE, 0xE0, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF8, 0xC0, 0x03, 0xFE, 0x7F, 0xFF, 0xFC, 0x03, 0x3F, 0x03, 0xEC, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0xE3, 0x80, 0x07, 0xEC, 0x3F, 0xFF, 0xF0, 0x00, 0x00, 0x33, 0xC0, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFF, 0x8F, 0xC0, 0x6F, 0xCC, 0x0F, 0xFF, 0xC0, 0x00, 0x03, 0xF6, 0x60, 0x7F, 0xFF, 
0xFF, 0xFF, 0xFC, 0x1F, 0x90, 0x4F, 0xC9, 0x03, 0xFC, 0x00, 0x00, 0x0F, 0xE4, 0xE1, 0xFF, 0xFF, 
0xFF, 0xFF, 0x80, 0x73, 0xB0, 0xDF, 0xC1, 0x00, 0x00, 0x00, 0x00, 0x01, 0x89, 0xC3, 0xFF, 0xFF, 
0xFF, 0xFF, 0x00, 0x07, 0xE0, 0x9F, 0xC3, 0x00, 0x00, 0x00, 0x00, 0x00, 0x63, 0x87, 0xFF, 0xFF, 
0xFF, 0xFE, 0x08, 0x1F, 0xE0, 0x9F, 0xC3, 0x80, 0x00, 0x00, 0x0E, 0x00, 0xE7, 0x07, 0xFF, 0xFF, 
0xFF, 0xF0, 0x21, 0xFF, 0xE0, 0x9F, 0xC2, 0x00, 0x00, 0x00, 0x3E, 0x00, 0x8C, 0x0F, 0xFF, 0xFF, 
0xFF, 0xF0, 0x07, 0xFE, 0x40, 0x8F, 0x84, 0x00, 0x00, 0x03, 0xFF, 0xFA, 0x3C, 0x0F, 0xFF, 0xFF, 
0xFF, 0xF0, 0x1F, 0xFC, 0xC0, 0x8F, 0x00, 0x00, 0x00, 0x3F, 0xFF, 0xFE, 0x00, 0x3F, 0xFF, 0xFF, 
0xFF, 0xC0, 0x3F, 0xF1, 0x81, 0xBE, 0x00, 0x00, 0x01, 0xFF, 0xFF, 0xFC, 0x00, 0xFF, 0xFF, 0xFF, 
0xFF, 0x80, 0x73, 0x82, 0x09, 0x3C, 0x00, 0x00, 0x07, 0xFF, 0xFF, 0xFC, 0x01, 0xFF, 0xFF, 0xFF, 
0xCE, 0x03, 0x80, 0x02, 0x13, 0x20, 0x04, 0x00, 0x1F, 0xFF, 0xFF, 0xFC, 0x03, 0xFF, 0xFF, 0xFF, 
0xE0, 0x00, 0x00, 0x00, 0x07, 0x00, 0x18, 0x00, 0x3F, 0xFF, 0xFF, 0xFE, 0x1F, 0xFF, 0xFF, 0xFF, 
0xA0, 0x00, 0x21, 0x00, 0xCC, 0x00, 0x70, 0x0C, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xC0, 0x07, 0x0F, 0xFF, 0x90, 0x01, 0xE0, 0x78, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x7F, 0xFF, 0x98, 0x0F, 0xC1, 0xE1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x98, 0x38, 0x01, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xA0, 0x7B, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x01, 0xF0, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x03, 0xF0, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFE, 0x0F, 0xE0, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFC, 0x1F, 0xE0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xF0, 0x1F, 0xC1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xE0, 0x3F, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC0, 0x7C, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x80, 0x78, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0x01, 0xF8, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE0, 0x07, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE0, 0x1E, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC0, 0x3C, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE0, 0xFC, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0xFE, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };
const unsigned char image9_con_de[] PROGMEM = { 0xFF, 0xFF, 0xF0, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x03, 0x87, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFC, 0x1E, 0x00, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF8, 0xFC, 0x87, 0xC0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF0, 0xF8, 0xFC, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xE3, 0xE3, 0xE0, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xC7, 0x9F, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xC6, 0x1F, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x8C, 0xFF, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x8C, 0xFE, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x8D, 0xFC, 0x3F, 0x81, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x8C, 0xFC, 0x78, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xC9, 0xDC, 0x00, 0xF8, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0x81, 0xFE, 0x07, 0xB8, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x3F, 
0xFE, 0x06, 0xFE, 0xDD, 0x20, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x0F, 
0xFC, 0x3F, 0x38, 0xBF, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0x87, 
0xF8, 0x7F, 0xEF, 0xFE, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xE3, 
0xF0, 0xFF, 0xFF, 0xF9, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xE1, 
0xF1, 0xF8, 0x1F, 0xFF, 0xF0, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xE0, 
0xE1, 0xFA, 0x7F, 0xFF, 0xF8, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xC0, 
0xE3, 0xF9, 0x3F, 0xFF, 0xFD, 0xC1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xA0, 0x00, 0x07, 0xC7, 0xD8, 
0xE1, 0xFF, 0xFF, 0xFF, 0xF9, 0xF0, 0x1F, 0xFF, 0xFF, 0xE0, 0x00, 0x01, 0xC4, 0x80, 0x0F, 0xF0, 
0xE3, 0xFF, 0xFF, 0x9F, 0x73, 0xE0, 0x00, 0x00, 0x9C, 0x02, 0x04, 0xFF, 0xFF, 0xFC, 0x1F, 0xE3, 
0x83, 0xFF, 0xFF, 0x3F, 0xF7, 0xCF, 0xF0, 0xC0, 0x00, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xE3, 
0x87, 0xFF, 0xFE, 0x7F, 0xEF, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x7F, 0xFF, 0xF7, 0xFD, 0x43, 
0x0F, 0xFF, 0xF1, 0xFF, 0xCE, 0x7F, 0xFF, 0xBF, 0xDF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF7, 0x0F, 
0x1F, 0xF3, 0xC7, 0xFF, 0x3D, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x3F, 
0x1B, 0xE7, 0x81, 0xFE, 0x73, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x7F, 
0x03, 0xCF, 0x00, 0xF1, 0xCF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x7F, 
0x80, 0x07, 0x98, 0x0F, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xFF, 
0xF0, 0x06, 0x80, 0x99, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xFF, 
0xFF, 0xE6, 0xC0, 0xA7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x7F, 
0xFF, 0xE1, 0x80, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x7F, 
0xFF, 0xF8, 0x01, 0x8F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x7F, 
0xFF, 0xFC, 0x03, 0xAF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x7F, 
0xFF, 0xFF, 0x87, 0x67, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xFF, 
0xFF, 0xFF, 0x0F, 0x77, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0xFF, 
0xFF, 0xFF, 0x80, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xFF, 
0xFF, 0xFF, 0xE0, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xDF, 0xFF, 0xFF, 0xF1, 0xFF, 
0xFF, 0xFF, 0xFF, 0x1F, 0xFF, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x07, 0xDB, 0xFF, 0xE1, 0xFF, 
0xFF, 0xFF, 0xFF, 0x83, 0xFF, 0xF9, 0xFF, 0xF7, 0xBF, 0xFF, 0xF8, 0x71, 0xFF, 0xFF, 0xE3, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC0, 0xFF, 0xB8, 0x3F, 0xFD, 0xFF, 0xFF, 0xE0, 0x0E, 0x07, 0xFF, 0xE1, 0xFF, 
0xFF, 0xFF, 0xFF, 0xC6, 0x7F, 0xE0, 0x00, 0x10, 0x00, 0x30, 0x03, 0x81, 0xF8, 0xFF, 0xF8, 0x7F, 
0xFF, 0xFF, 0xFF, 0xC6, 0x7F, 0xE1, 0xE4, 0x20, 0x00, 0x01, 0xFF, 0xF0, 0x3F, 0x3F, 0xFC, 0x3F, 
0xFF, 0xFF, 0xFF, 0x87, 0x3F, 0xE3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x1F, 0x9F, 0xFE, 0x1F, 
0xFF, 0xFF, 0xFF, 0x87, 0x7F, 0xC7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xCF, 0xFF, 0x8F, 
0xFF, 0xFF, 0xFE, 0x0F, 0x7F, 0x8F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0xE7, 0xFF, 0x8F, 
0xFF, 0xFF, 0xFC, 0x3E, 0x7E, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x1F, 0xE7, 0xF5, 0x0F, 
0xFF, 0xFF, 0xF8, 0x7E, 0xFE, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x3F, 0xE7, 0xFE, 0x1F, 
0xFF, 0xFF, 0xF8, 0x7C, 0xFC, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x7F, 0xC7, 0xFC, 0x3F, 
0xFF, 0xFF, 0xF8, 0x79, 0xFC, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x7F, 0x13, 0xF8, 0x7F, 
0xFF, 0xFF, 0xF0, 0xF9, 0xFC, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF1, 0xFE, 0x73, 0xF0, 0xFF, 
0xFF, 0xFF, 0xF1, 0xFD, 0xF8, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xFC, 0xF3, 0xF1, 0xFF, 
0xFF, 0xFF, 0xE1, 0xF9, 0xF8, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x87, 0xF9, 0xF3, 0xE3, 0xFF, 
0xFF, 0xFF, 0xC3, 0xF3, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xF3, 0xE7, 0xC7, 0xFF, 
0xFF, 0xFF, 0x87, 0xE7, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x3F, 0xE7, 0xCF, 0xC7, 0xFF, 
0xFF, 0xFF, 0x8F, 0xE7, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x3F, 0xE7, 0x1F, 0xC7, 0xFF, 
0xFF, 0xFF, 0x0F, 0xCF, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0xE0, 0x0E, 0x7F, 0xC7, 0xFF, 
0xFF, 0xFC, 0x13, 0x9F, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xF8, 0x00, 0xFF, 0xC3, 0xFF, 
0xFF, 0xFC, 0x3E, 0x17, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC6, 0x78, 0xC3, 0x38, 0x07, 0xFF, 
0xFF, 0xFC, 0x00, 0xF8, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x00, 0x87, 0xF0, 0x1F, 0xFF, 
0xFF, 0xFE, 0x01, 0xD8, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0x81, 0x8E, 0xF8, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0x30, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF0, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x07, 0xFF, 0xFF,  
 };
const unsigned char image10_con_khi[] PROGMEM = { 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x00, 0x00, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x00, 0x00, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0x00, 0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x00, 0x00, 0x00, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0x00, 0x00, 0x00, 0x00, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0x30, 0x00, 0x00, 0x18, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x03, 0xFF, 0x80, 0x00, 0xFF, 0xC0, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x0F, 0xFF, 0xE0, 0x03, 0xFF, 0xF0, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x3F, 0xFF, 0xF8, 0x0F, 0xFF, 0xFC, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x7F, 0xFF, 0xFC, 0x1F, 0xFF, 0xFE, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0xFF, 0xFF, 0xFE, 0x3F, 0xFF, 0xFF, 0x01, 0xFC, 0x0F, 0xFF, 0xFF, 
0xFF, 0xFF, 0x80, 0x0F, 0x81, 0xFF, 0xFF, 0xFE, 0x7F, 0xFF, 0xFF, 0x01, 0xE0, 0x01, 0xFF, 0xFF, 
0xFF, 0xFE, 0x00, 0x03, 0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x81, 0x00, 0x00, 0x7F, 0xFF, 
0xFF, 0xF8, 0x00, 0x00, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0x00, 0x00, 0x1F, 0xFF, 
0xFF, 0xF0, 0x02, 0x00, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x03, 0xF0, 0x0F, 0xFF, 
0xFF, 0xE0, 0x3F, 0xE0, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC0, 0x0F, 0xFC, 0x0F, 0xFF, 
0xFF, 0xE0, 0xFF, 0xF8, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x3F, 0xFF, 0x07, 0xFF, 
0xFF, 0xC1, 0xFF, 0xFE, 0x07, 0xFF, 0xC0, 0xFF, 0xFE, 0x07, 0xFF, 0xE0, 0xFF, 0xFF, 0x07, 0xFF, 
0xFF, 0xC3, 0xFF, 0xFF, 0x07, 0xFF, 0x80, 0x7F, 0xFC, 0x33, 0xFF, 0xE0, 0xFF, 0xFF, 0x83, 0xFF, 
0xFF, 0x83, 0xFF, 0xFF, 0x07, 0xFF, 0x0F, 0x7F, 0xFC, 0x79, 0xFF, 0xE1, 0xFF, 0xFF, 0xC3, 0xFF, 
0xFF, 0x87, 0xFF, 0xFF, 0x07, 0xFF, 0x0F, 0x3F, 0xF8, 0x79, 0xFF, 0xE1, 0x8F, 0xFF, 0xC3, 0xFF, 
0xFF, 0x07, 0xFF, 0xC1, 0x07, 0xFE, 0x06, 0x3F, 0xF8, 0x21, 0xFF, 0xE0, 0x21, 0xFF, 0xC1, 0xFF, 
0xFF, 0x87, 0xFF, 0x1E, 0x07, 0xFE, 0x00, 0x3F, 0xF8, 0x00, 0xFF, 0xC1, 0xFC, 0x7F, 0xE1, 0xFF, 
0xFF, 0x8F, 0xFE, 0x7F, 0x87, 0xFE, 0x00, 0x3F, 0xF8, 0x00, 0xFF, 0xC1, 0xFE, 0x7F, 0xE1, 0xFF, 
0xFF, 0x0F, 0xFC, 0xFF, 0x83, 0xFE, 0x00, 0x3F, 0xF8, 0x01, 0xFF, 0xC3, 0xFF, 0x3F, 0xE3, 0xFF, 
0xFF, 0x07, 0xFC, 0xFF, 0x83, 0xFF, 0x38, 0x3F, 0xF8, 0xC1, 0xFF, 0x83, 0xFF, 0x3F, 0xC1, 0xFF, 
0xFF, 0x87, 0xF9, 0xFF, 0xC1, 0xFF, 0x38, 0x3F, 0xF8, 0xC1, 0xFF, 0x83, 0xFF, 0x3F, 0xC3, 0xFF, 
0xFF, 0x87, 0xF9, 0xFF, 0xC0, 0xFF, 0x90, 0x7F, 0xFC, 0xC3, 0xFF, 0x07, 0xFF, 0x3F, 0xC3, 0xFF, 
0xFF, 0x87, 0xFC, 0xFF, 0xE0, 0x5F, 0x80, 0xFF, 0xFE, 0x07, 0xF8, 0x07, 0xFF, 0x3F, 0x83, 0xFF, 
0xFF, 0x83, 0xFC, 0xFF, 0xF0, 0x1F, 0xE3, 0xFF, 0xFF, 0x0F, 0xFC, 0x0F, 0xFE, 0x7F, 0x87, 0xFF, 
0xFF, 0xC1, 0xFC, 0xFF, 0xF0, 0xFF, 0xFF, 0xF0, 0x1F, 0xFF, 0xFF, 0x8F, 0xFC, 0xFF, 0x07, 0xFF, 
0xFF, 0xC1, 0xFE, 0x3F, 0xE3, 0xFF, 0xFF, 0xE0, 0x07, 0xFF, 0xFF, 0xC0, 0x81, 0xFE, 0x0F, 0xFF, 
0xFF, 0xE0, 0x7F, 0x80, 0x07, 0xFF, 0xFF, 0xE8, 0x07, 0xFF, 0xFF, 0xE0, 0x1F, 0xF8, 0x0F, 0xFF, 
0xFF, 0xF0, 0x3F, 0xF0, 0x07, 0xFF, 0xFF, 0xFE, 0x7F, 0xFF, 0xFF, 0xE0, 0x3F, 0xE0, 0x1F, 0xFF, 
0xFF, 0xF8, 0x07, 0xF0, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0x00, 0x7F, 0xFF, 
0xFF, 0xFC, 0x00, 0x00, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x00, 0x00, 0xFF, 0xFF, 
0xFF, 0xFF, 0x00, 0x00, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xDF, 0xF0, 0x00, 0x03, 0xFF, 0xFF, 
0xFF, 0xFF, 0xC0, 0x01, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 0xF1, 0xE0, 0x1F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF2, 0x4F, 0x0F, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xF1, 0xFF, 0xFF, 0xFF, 0xFE, 0x7F, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x0F, 0xF4, 0x7F, 0xFF, 0xFF, 0xF9, 0xFF, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x8F, 0xFF, 0x1F, 0xFF, 0xFF, 0xC3, 0xFF, 0xE1, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0x87, 0xFF, 0xC1, 0xFF, 0xFE, 0x1F, 0xFF, 0xE1, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xFF, 0xF8, 0x04, 0x80, 0x7F, 0xFF, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xC3, 0xFF, 0xFF, 0x80, 0x07, 0xFF, 0xFF, 0x83, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xE1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x0F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF0, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x80, 0x7F, 0xFF, 0xFF, 0xFE, 0x03, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x0F, 0xFF, 0xFF, 0xF0, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF8, 0x00, 0xFF, 0xFF, 0x00, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE0, 0x00, 0x00, 0x07, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x00, 0x00, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, };
const unsigned char image11_con_ga[] PROGMEM = {0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xDF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF9, 0x98, 0x31, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xE7, 0xFC, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xFF, 0xFF, 0x0F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFF, 0xFF, 0xF3, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 0xC9, 0xFF, 0xF9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3E, 0x7E, 0x67, 0xF9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3B, 0xFD, 0xFC, 0x07, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xB7, 0xFD, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xCE, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xFF, 0xFE, 0xC3, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFF, 0xF6, 0xF9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0xB0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFE, 0xCD, 0xFC, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xBF, 0x8E, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xEF, 0xF1, 0x33, 0xFE, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0x1C, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xEF, 0xE7, 0xBF, 0x82, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0xBC, 0xF7, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xF6, 0xFC, 0xDF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0xBD, 0x89, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xFB, 0x8E, 0x3F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x5F, 0xBC, 0x39, 0xFF, 0xFF, 0xFF, 0xFF, 0xEF, 0xFC, 0x23, 0xC1, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x6F, 0xFC, 0x73, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFB, 0xFF, 0xFC, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x7F, 0xDC, 0xF3, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFB, 0xFF, 0xF9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x7F, 0xEE, 0xF7, 0xFF, 0xFF, 0xFF, 0xFF, 0xDF, 0xFD, 0xFF, 0x87, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x3F, 0xFF, 0xF7, 0xFF, 0xF4, 0x9F, 0xFF, 0x3F, 0xFE, 0x7F, 0x5F, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xBF, 0xFF, 0xF3, 0xFC, 0x0F, 0xF0, 0x30, 0xFF, 0xFF, 0xC1, 0xE7, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x1F, 0xFF, 0xF3, 0xC3, 0xFF, 0xFF, 0xCF, 0xFF, 0xFF, 0xFF, 0xF1, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x6F, 0xFF, 0xFA, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x7F, 0xFF, 0xFF, 
0xFF, 0xFE, 0x77, 0xFF, 0xFD, 0xFF, 0xFF, 0xFF, 0xEF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 0xFF, 0xFF, 
0xFF, 0xFE, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xCF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 0xFF, 0xFF, 
0xFF, 0xFF, 0x3F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xFF, 0xFF, 0xFF, 0xEF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x9B, 0xFF, 0xFF, 0xFF, 0xDF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xCF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFB, 0xFF, 0xFF, 0xFF, 0x9F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xCF, 0xFF, 0xFF, 0xFD, 0xFF, 0xFF, 0xFF, 0x09, 0xFF, 0xFF, 0xEB, 0x9F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xE7, 0xFB, 0xFF, 0xF7, 0xCF, 0xFF, 0xFF, 0xF2, 0x67, 0xFF, 0xEC, 0x3F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xF3, 0xF7, 0xE5, 0xF6, 0x7E, 0xFF, 0xFF, 0xF9, 0xF7, 0xE7, 0xDD, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFC, 0x77, 0xDF, 0x3F, 0xB7, 0xFF, 0xFF, 0xFF, 0xF9, 0x38, 0x3D, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF9, 0xFF, 0x87, 0xDF, 0xEF, 0xFD, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xF9, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFE, 0x06, 0xE7, 0xCF, 0xFC, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF3, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0x9E, 0xF7, 0xF7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xC7, 0xFF, 0xFF, 0xFF, 
0xFF, 0xF0, 0x7F, 0xF3, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xB0, 0x0F, 0xFF, 0xFF, 
0xFF, 0xFC, 0x7F, 0xFB, 0x9E, 0x3F, 0xFF, 0xFF, 0xFF, 0xFD, 0xFF, 0xFC, 0xED, 0xCB, 0x7F, 0xFF, 
0xFF, 0x87, 0xFF, 0xFD, 0x8F, 0xE7, 0xFF, 0xFF, 0xFF, 0xF7, 0xFF, 0xF3, 0xFF, 0xBE, 0x03, 0xFF, 
0xFC, 0xFF, 0xFF, 0xFF, 0x62, 0xFC, 0x7F, 0xFF, 0xFF, 0x3F, 0xFF, 0x8F, 0xFF, 0xFF, 0x87, 0xFF, 
0xF3, 0xFF, 0xFF, 0xFF, 0xBE, 0x7F, 0xC0, 0x5B, 0x23, 0xFF, 0xFD, 0xBF, 0x9F, 0xFF, 0xFC, 0xFF, 
0xED, 0xFF, 0xFB, 0x7F, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xF7, 0xFF, 0xFE, 0x3F, 
0xD3, 0xFF, 0xCF, 0xFF, 0x7E, 0x9F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0xFF, 0xFF, 0xFF, 0xFF, 0x9F, 
0x87, 0xFF, 0xBF, 0xFF, 0x3F, 0xEF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xFF, 0xFD, 0xFF, 0xFF, 0xEF, 
0x8F, 0xFF, 0x7F, 0xFF, 0xBF, 0xB3, 0xFF, 0xFF, 0xFF, 0x92, 0x1C, 0xFF, 0xFF, 0xFF, 0xFF, 0xE7, 
0xAB, 0xFE, 0xFF, 0xFF, 0xFF, 0xDC, 0xFF, 0xFF, 0xFE, 0x7F, 0x9F, 0x3F, 0xBF, 0xFF, 0xFF, 0xF7, 
0xEB, 0xFF, 0xFF, 0xFF, 0xF5, 0xFF, 0x3F, 0xFF, 0xF1, 0xF5, 0xFF, 0xFB, 0xBF, 0xFF, 0xBF, 0xF3, 
0xE5, 0xFF, 0x7F, 0xFF, 0xF7, 0xFF, 0xE1, 0xF8, 0x0E, 0x97, 0xFF, 0xFD, 0xBF, 0xFF, 0xDF, 0xFB, 
0xF3, 0xFF, 0xDF, 0xFF, 0xEF, 0xFF, 0xDE, 0x0F, 0xE6, 0x6F, 0xFF, 0xFD, 0xBF, 0xFF, 0xFF, 0xD9, 
0xF3, 0xFF, 0xFB, 0x7F, 0xDF, 0xFF, 0xDF, 0xF7, 0xB1, 0x5F, 0xF7, 0xFF, 0xDF, 0xFF, 0xEF, 0xCD, 
0xF6, 0xFF, 0xFF, 0xFF, 0xDF, 0xFF, 0xBF, 0xFD, 0x9E, 0xEF, 0xF9, 0xFF, 0xF7, 0xFF, 0xDF, 0xE5, 
0xF2, 0xFF, 0xFF, 0xFF, 0xBF, 0xFF, 0xBF, 0xFF, 0xEF, 0xFF, 0x6D, 0xA7, 0xFD, 0xFF, 0x7E, 0x63, 
0xFB, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x7F, 0xFF, 0xFF, 0xF8, 0x3C, 0x7F, 0xFF, 0xDB, 0xFE, 0x2F, 
0xFE, 0x2F, 0xFF, 0xFF, 0xDF, 0xFD, 0xFF, 0xFF, 0xFF, 0xE3, 0xF7, 0xFF, 0xFF, 0xFF, 0xFE, 0x8F, 
0xFF, 0xC7, 0xFF, 0xFF, 0xF7, 0xD7, 0xFF, 0xFF, 0xFF, 0xBF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC, 0x9F, 
0xFF, 0xF9, 0x7F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFD, 0xFF, 
0xFF, 0xFF, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFD, 0xB3, 0xFF, 
0xFF, 0xFF, 0xE0, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xF3, 0x0F, 0xFF, 
0xFF, 0xFF, 0xFF, 0x3C, 0xFF, 0xF7, 0xFF, 0xFF, 0xFF, 0xFF, 0xFB, 0xFD, 0xFF, 0xC0, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xE7, 0x1B, 0x10, 0x01, 0xFF, 0xFF, 0xFF, 0xCE, 0x01, 0x00, 0x2F, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFA, 0xFF, 0xFF, 0x03, 0xFF, 0xFF, 0xF1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0x3F, 0x09, 0x1F, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 
0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xE3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,};

const unsigned char* const allBitmaps[] PROGMEM = { 
  image0_con_meo,  // ID: 0
  image1_con_chuot,  // ID: 1
  image2_con_cho,  // ID: 2
  image3_con_trau,  // ID: 3
  image4_con_ho,  // ID: 4
  image5_con_rong,  // ID: 5
  image6_con_ran,  // ID: 6
  image7_con_lon,  // ID: 7
  image8_con_ngua,  // ID: 8
  image9_con_de,  // ID: 9
  image10_con_khi, // ID: 10
  image11_con_ga, // ID: 11
};

// Tổng số lượng biểu cảm
const int frameCount = 13;
void showFace(int id) {
  
  if (OLED_BUS == 0) {
    tcaSelect(Wire, OLED_CHANNEL);
  } else {
    tcaSelect(Wire1, OLED_CHANNEL);
  }
  // Tạo biến tạm để chứa dữ liệu hình ảnh sẽ vẽ
  const unsigned char* bitmap_to_draw;

  // Dùng switch case để gán thủ công, đảm bảo chính xác 100%
  switch (id) {
    case 0: bitmap_to_draw = image0_con_meo; break;
    case 1: bitmap_to_draw = image1_con_chuot; break;
    case 2: bitmap_to_draw = image2_con_cho; break;
    case 3: bitmap_to_draw = image3_con_trau; break;
    case 4: bitmap_to_draw = image4_con_ho; break;
    case 5: bitmap_to_draw = image5_con_rong; break;
    case 6: bitmap_to_draw = image6_con_ran; break;
    case 7: bitmap_to_draw = image7_con_lon; break;
    case 8: bitmap_to_draw = image8_con_ngua; break;
    case 9: bitmap_to_draw = image9_con_de; break;
    case 10: bitmap_to_draw = image10_con_khi; break;
    case 11: bitmap_to_draw = image11_con_ga; break;
    default: return; 
  }
  display.clearDisplay();
  
  display.drawBitmap(0, 0, bitmap_to_draw, SCREEN_WIDTH, SCREEN_HEIGHT, 1);
  
  display.display();
}\n`;